(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9919],{

/***/ 39541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ $createTableBlockNode; },
/* harmony export */   "v": function() { return /* binding */ CustomTableBlockNode; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61084);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18824);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var CustomTableBlockNode = /*#__PURE__*/function (_ElementNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CustomTableBlockNode, _ElementNode);

  var _super = _createSuper(CustomTableBlockNode);

  function CustomTableBlockNode(isScrollable, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, CustomTableBlockNode);

    _this = _super.call(this, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this), "__isScrollable", void 0);

    _this.__isScrollable = isScrollable;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CustomTableBlockNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomTableBlockNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "custom-table-block",
        version: 1
      });
    }
  }, {
    key: "createDOM",
    value: function createDOM(config) {
      var dom = document.createElement("div");
      var classes = [config.theme.tableBlock];

      if (this.__isScrollable) {
        classes.push(config.theme.tableBlockScrollable);
      }

      _lexical_utils__WEBPACK_IMPORTED_MODULE_8__/* .addClassNamesToElement.apply */ .Yo.apply(void 0, [dom].concat(classes));
      return dom;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getIsScrollable",
    value: function getIsScrollable() {
      return this.__isScrollable;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "custom-table-block";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new CustomTableBlockNode(node.__isScrollable, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(_serializedNode) {
      return $createTableBlockNode();
    }
  }]);

  return CustomTableBlockNode;
}(lexical__WEBPACK_IMPORTED_MODULE_9__/* .ElementNode */ .HX);
function $createTableBlockNode() {
  var isScrollable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (0,lexical__WEBPACK_IMPORTED_MODULE_9__/* .$applyNodeReplacement */ .U2)(new CustomTableBlockNode(isScrollable));
}

/***/ }),

/***/ 12292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CustomTableInnerNode; },
/* harmony export */   "z": function() { return /* binding */ $createTableInnerNode; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61084);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18824);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var CustomTableInnerNode = /*#__PURE__*/function (_ElementNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CustomTableInnerNode, _ElementNode);

  var _super = _createSuper(CustomTableInnerNode);

  function CustomTableInnerNode() {
    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, CustomTableInnerNode);

    return _super.apply(this, arguments);
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CustomTableInnerNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomTableInnerNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "custom-table-inner",
        version: 1
      });
    }
  }, {
    key: "createDOM",
    value: function createDOM(config) {
      var dom = document.createElement("div");
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_7__/* .addClassNamesToElement */ .Yo)(dom, config.theme.tableBlockInner);
      return dom;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "custom-table-inner";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new CustomTableInnerNode(node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(_serializedNode) {
      return $createTableInnerNode();
    }
  }]);

  return CustomTableInnerNode;
}(lexical__WEBPACK_IMPORTED_MODULE_8__/* .ElementNode */ .HX);
function $createTableInnerNode() {
  return (0,lexical__WEBPACK_IMPORTED_MODULE_8__/* .$applyNodeReplacement */ .U2)(new CustomTableInnerNode());
}

/***/ }),

/***/ 52919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CustomTableNode; }
/* harmony export */ });
/* unused harmony export $createCustomTableNode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27812);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _lexical_table__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79380);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61084);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18824);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// 記事詳細でスマホ幅の場合にテーブルをスクロールできるようにする
// https://github.com/NinNinInc/tabi/pull/2335
// https://github.com/NinNinInc/tabi/issues/2321
// に対応するためにLexicalのコア機能のTableNodeをオーバーライド



var CustomTableNode = /*#__PURE__*/function (_TableNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CustomTableNode, _TableNode);

  var _super = _createSuper(CustomTableNode);

  function CustomTableNode() {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, CustomTableNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this), "__isScrollable", void 0);

    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CustomTableNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomTableNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "custom-table",
        version: 1
      });
    }
  }, {
    key: "createDOM",
    value: function createDOM(config) {
      var tableElement = document.createElement("table");
      var classes = [config.theme.table];

      if (this.__isScrollable) {
        classes.push(config.theme.tableScrollable);
      }

      _lexical_utils__WEBPACK_IMPORTED_MODULE_8__/* .addClassNamesToElement.apply */ .Yo.apply(void 0, [tableElement].concat(classes));
      return tableElement;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var _this2 = this;

      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomTableNode.prototype), "exportDOM", this).call(this, editor)), {}, {
        after: function after(tableElement) {
          if (tableElement) {
            var newElement = tableElement.cloneNode();
            var colGroup = document.createElement("colgroup");
            var tBody = document.createElement("tbody");

            if ((0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .isHTMLElement */ .Re)(tableElement)) {
              tBody.append.apply(tBody, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(tableElement.children));
            }

            var firstRow = _this2.getFirstChildOrThrow();

            if (!(0,_lexical_table__WEBPACK_IMPORTED_MODULE_11__/* .$isTableRowNode */ .to)(firstRow)) {
              throw new Error("Expected to find row node.");
            }

            var colCount = firstRow.getChildrenSize();

            for (var i = 0; i < colCount; i++) {
              var col = document.createElement("col");
              colGroup.append(col);
            }

            newElement.replaceChildren(colGroup, tBody);
            var wrapElement = document.createElement("div");
            var innerElement = document.createElement("div");
            var theme = editor._config.theme;
            var blockClassName = theme.tableBlock;
            var blockScrollableClassName = theme.tableBlockScrollable;
            var innerClassName = theme.tableBlockInner;
            var scrollableClassName = theme.tableScrollable;

            if (blockClassName !== undefined) {
              wrapElement.className = blockClassName;
            }

            if (innerClassName !== undefined) {
              innerElement.className = innerClassName;
            }

            if ((0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .isHTMLElement */ .Re)(newElement)) {
              if (colCount >= 4) {
                wrapElement.classList.add(blockScrollableClassName);
                newElement.classList.add(scrollableClassName);
                newElement.setAttribute("data-col-count", String(colCount));
              }
            }

            innerElement.append(newElement);
            wrapElement.append(innerElement);
            return wrapElement;
          }
        }
      });
    }
  }, {
    key: "setIsScrollable",
    value: function setIsScrollable(isScrollable) {
      var self = this.getWritable();
      self.__isScrollable = isScrollable;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "custom-table";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new CustomTableNode(node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(_serializedNode) {
      return $createCustomTableNode();
    }
  }]);

  return CustomTableNode;
}(_lexical_table__WEBPACK_IMPORTED_MODULE_11__/* .TableNode */ .Fh);
function $createCustomTableNode() {
  return (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$applyNodeReplacement */ .U2)(new CustomTableNode());
}

/***/ }),

/***/ 25478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ $createImageNode; },
/* harmony export */   "HJ": function() { return /* binding */ ImageNode; },
/* harmony export */   "dP": function() { return /* binding */ $isImageNode; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lexical_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70573);
/* harmony import */ var _lexical_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42693);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */






var ImageComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.lazy( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function () {
  return __webpack_require__.e(/* import() */ 6585).then(__webpack_require__.bind(__webpack_require__, 76585));
});

function isGoogleDocCheckboxImg(img) {
  return img.parentElement != null && img.parentElement.tagName === "LI" && img.previousSibling === null && img.getAttribute("aria-roledescription") === "checkbox";
}

function $convertImageElement(domNode) {
  var img = domNode;

  if (img.src.startsWith("file:///") || isGoogleDocCheckboxImg(img)) {
    return null;
  }

  var altText = img.alt,
      src = img.src,
      width = img.width,
      height = img.height;
  var node = $createImageNode({
    altText: altText,
    height: height,
    src: src,
    width: width
  });
  return {
    node: node
  };
}

var ImageNode = /*#__PURE__*/function (_DecoratorNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ImageNode, _DecoratorNode);

  var _super = _createSuper(ImageNode);

  function ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ImageNode);

    _this = _super.call(this, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__src", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__altText", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__width", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__height", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__maxWidth", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__showCaption", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__caption", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "__captionsEnabled", void 0);

    _this.__src = src;
    _this.__altText = altText;
    _this.__maxWidth = maxWidth;
    _this.__width = width || "inherit";
    _this.__height = height || "inherit";
    _this.__showCaption = showCaption || false;
    _this.__caption = caption || (0,lexical__WEBPACK_IMPORTED_MODULE_7__/* .createEditor */ .Jh)({
      // LinkNodeを設定しないとキャプション内にリンクがある場合レンダリングされない
      nodes: [_lexical_link__WEBPACK_IMPORTED_MODULE_8__/* .LinkNode */ .GR]
    });
    _this.__captionsEnabled = captionsEnabled || captionsEnabled === undefined;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(ImageNode, [{
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("figure");
      var img = document.createElement("img");
      var figcaption = document.createElement("figcaption");
      var theme = editor._config.theme;
      var className = theme.image;

      if (className !== undefined) {
        element.className = className;
      }

      img.src = this.__src;
      img.alt = this.__altText; // Google Docsからコピペした際にdocs上のwidth/heightが設定されてしまうため
      // 一旦設定しないようにする
      // if (typeof this.__width == "number") {
      //   img.width = this.__width;
      // }
      // if (typeof this.__height == "number") {
      //   img.height = this.__height;
      // }

      img.loading = "lazy";
      element.appendChild(img);
      var captionEditor = this.__caption;

      if (captionEditor) {
        var captionHtml = captionEditor.getEditorState().read(function () {
          return (0,_lexical_html__WEBPACK_IMPORTED_MODULE_10__/* .$generateHtmlFromNodes */ .S)(captionEditor, null);
        });

        if (captionHtml) {
          figcaption.insertAdjacentHTML("beforeend", captionHtml);
          element.appendChild(figcaption);
        }
      }

      return {
        element: element
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        altText: this.getAltText(),
        caption: this.__caption.toJSON(),
        height: this.__height === "inherit" ? 0 : this.__height,
        maxWidth: this.__maxWidth,
        showCaption: this.__showCaption,
        src: this.getSrc(),
        type: "image",
        version: 1,
        width: this.__width === "inherit" ? 0 : this.__width
      };
    }
  }, {
    key: "setWidthAndHeight",
    value: function setWidthAndHeight(width, height) {
      var writable = this.getWritable();
      writable.__width = width;
      writable.__height = height;
    }
  }, {
    key: "setShowCaption",
    value: function setShowCaption(showCaption) {
      var writable = this.getWritable();
      writable.__showCaption = showCaption;
    }
  }, {
    key: "setSrc",
    value: function setSrc(src) {
      var writable = this.getWritable();
      writable.__src = src;
    } // View

  }, {
    key: "createDOM",
    value: function createDOM(config) {
      // インライン画像には非対応
      var dom = document.createElement("figure");
      var theme = config.theme;
      var className = theme.image;

      if (className !== undefined) {
        dom.className = className;
      }

      return dom;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.__src;
    }
  }, {
    key: "getAltText",
    value: function getAltText() {
      return this.__altText;
    }
  }, {
    key: "decorate",
    value: function decorate() {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
        fallback: null,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ImageComponent, {
          src: this.__src,
          altText: this.__altText // Google Docsからコピペした際にdocs上のwidth/heightが設定されてしまうため
          // 一旦設定しないようにする
          ,
          width: null,
          height: null // width={this.__width}
          // height={this.__height}
          ,
          maxWidth: this.__maxWidth,
          nodeKey: this.getKey(),
          showCaption: this.__showCaption,
          caption: this.__caption,
          captionsEnabled: this.__captionsEnabled,
          resizable: true
        })
      });
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return false;
    }
  }], [{
    key: "getType",
    value: // Captions cannot yet be used within editor cells
    function getType() {
      return "image";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new ImageNode(node.__src, node.__altText, node.__maxWidth, node.__width, node.__height, node.__showCaption, node.__caption, node.__captionsEnabled, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var altText = serializedNode.altText,
          height = serializedNode.height,
          width = serializedNode.width,
          maxWidth = serializedNode.maxWidth,
          caption = serializedNode.caption,
          src = serializedNode.src,
          showCaption = serializedNode.showCaption;
      var node = $createImageNode({
        altText: altText,
        height: height,
        maxWidth: maxWidth,
        showCaption: showCaption,
        src: src,
        width: width
      });
      var nestedEditor = node.__caption;
      var editorState = nestedEditor.parseEditorState(caption.editorState);

      if (!editorState.isEmpty()) {
        nestedEditor.setEditorState(editorState);
      }

      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        img: function img(_) {
          return {
            conversion: $convertImageElement,
            priority: 0
          };
        }
      };
    }
  }]);

  return ImageNode;
}(lexical__WEBPACK_IMPORTED_MODULE_7__/* .DecoratorNode */ .Ij);
function $createImageNode(_ref) {
  var altText = _ref.altText,
      height = _ref.height,
      maxWidth = _ref.maxWidth,
      captionsEnabled = _ref.captionsEnabled,
      src = _ref.src,
      width = _ref.width,
      showCaption = _ref.showCaption,
      caption = _ref.caption,
      key = _ref.key;
  return (0,lexical__WEBPACK_IMPORTED_MODULE_7__/* .$applyNodeReplacement */ .U2)(new ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key));
}
function $isImageNode(node) {
  return node instanceof ImageNode;
}

/***/ }),

/***/ 95706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": function() { return /* binding */ InstagramNode; },
/* harmony export */   "rY": function() { return /* binding */ $createInstagramNode; }
/* harmony export */ });
/* unused harmony export $isInstagramNode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22587);
/* harmony import */ var _lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var WIDGET_SCRIPT_URL = "//www.instagram.com/embed.js";

function generateInstagramEmbedCode(_ref) {
  var postID = _ref.postID;
  // permalinkはreelやtvの場合に/p/が/reel/等に変化するが
  // pでも表示できるようなのでp固定にしている
  return "<blockquote class=\"instagram-media\" data-instgrm-captioned data-instgrm-permalink=\"https://www.instagram.com/p/".concat(postID, "/?utm_source=ig_embed&amp;utm_campaign=loading\" data-instgrm-version=\"14\" style=\" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);\"><div style=\"padding:16px;\"> <a href=\"https://www.instagram.com/p/").concat(postID, "/?utm_source=ig_embed&amp;utm_campaign=loading\" style=\" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;\" target=\"_blank\"> <div style=\" display: flex; flex-direction: row; align-items: center;\"> <div style=\"background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;\"></div> <div style=\"display: flex; flex-direction: column; flex-grow: 1; justify-content: center;\"> <div style=\" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;\"></div> <div style=\" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;\"></div></div></div><div style=\"padding: 19% 0;\"></div> <div style=\"display:block; height:50px; margin:0 auto 12px; width:50px;\"><svg width=\"50px\" height=\"50px\" viewBox=\"0 0 60 60\" version=\"1.1\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-511.000000, -20.000000)\" fill=\"#000000\"><g><path d=\"M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631\"></path></g></g></g></svg></div><div style=\"padding-top: 8px;\"> <div style=\" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;\">\u3053\u306E\u6295\u7A3F\u3092Instagram\u3067\u898B\u308B</div></div><div style=\"padding: 12.5% 0;\"></div> <div style=\"display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;\"><div> <div style=\"background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);\"></div> <div style=\"background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;\"></div> <div style=\"background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);\"></div></div><div style=\"margin-left: 8px;\"> <div style=\" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;\"></div> <div style=\" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)\"></div></div><div style=\"margin-left: auto;\"> <div style=\" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);\"></div> <div style=\" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);\"></div> <div style=\" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);\"></div></div></div> <div style=\"display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;\"> <div style=\" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;\"></div> <div style=\" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;\"></div></div></a><p style=\" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;\"></p></div></blockquote>");
}

function convertInstagramElement(domNode) {
  var id = domNode.getAttribute("data-lexical-instagram-id");

  if (id) {
    var node = $createInstagramNode(id);
    return {
      node: node
    };
  }

  return null;
}

var isInstagramScriptLoading = true;

function InstagramComponent(_ref2) {
  var className = _ref2.className,
      instagramClassName = _ref2.instagramClassName,
      format = _ref2.format,
      nodeKey = _ref2.nodeKey,
      onError = _ref2.onError,
      onLoad = _ref2.onLoad,
      postID = _ref2.postID;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
  var previousInstagramIDRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(""); // const [isInstagramLoading, setIsInstagramLoading] = useState(false);

  var createInstagram = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function () {
    try {
      // @ts-expect-error Instagram is attached to the window.
      window.instgrm.Embeds.process(); // setIsInstagramLoading(false);

      isInstagramScriptLoading = false;

      if (onLoad) {
        onLoad();
      }
    } catch (error) {
      if (onError) {
        onError(String(error));
      }
    }
  }, [onError, onLoad, postID]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (postID !== previousInstagramIDRef.current) {
      // setIsInstagramLoading(true);
      var instagramScript = document.querySelector("script[src=\"".concat(WIDGET_SCRIPT_URL, "\"]"));

      if (isInstagramScriptLoading && !instagramScript) {
        var _document$body;

        var script = document.createElement("script");
        script.src = WIDGET_SCRIPT_URL;
        script.async = true;
        (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(script);

        script.onload = function () {
          script.setAttribute("data-loaded", "true");
          createInstagram();
        };

        if (onError) {
          script.onerror = onError;
        }
      } else {
        if (instagramScript.hasAttribute("data-loaded")) {
          createInstagram();
        } else {
          instagramScript.addEventListener("load", function () {
            createInstagram();
          });
        }
      }

      if (previousInstagramIDRef) {
        previousInstagramIDRef.current = postID;
      }
    }
  }, [createInstagram, onError, postID]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_5__/* .BlockWithAlignableContents */ .U, {
    className: className,
    format: format,
    nodeKey: nodeKey,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      className: instagramClassName,
      style: {
        display: "inline-block",
        width: "550px"
      },
      ref: containerRef,
      dangerouslySetInnerHTML: {
        __html: generateInstagramEmbedCode({
          postID: postID
        })
      }
    })
  });
}

var InstagramNode = /*#__PURE__*/function (_DecoratorBlockNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(InstagramNode, _DecoratorBlockNode);

  var _super = _createSuper(InstagramNode);

  function InstagramNode(id, format, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, InstagramNode);

    _this = _super.call(this, format, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "__id", void 0);

    _this.__id = id;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(InstagramNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InstagramNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "instagram",
        version: 1,
        postID: this.__id
      });
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("div");
      element.setAttribute("data-lexical-instagram-id", this.__id);
      var theme = editor._config.theme;
      var className = theme.instagram;

      if (className !== undefined) {
        element.className = className;
      }

      element.innerHTML = generateInstagramEmbedCode({
        postID: this.__id
      });
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.__id;
    }
  }, {
    key: "decorate",
    value: function decorate(_editor, config) {
      var embedBlockTheme = config.theme.embedBlock || {};
      var className = {
        base: embedBlockTheme.base || "",
        focus: embedBlockTheme.focus || ""
      };
      var instagramClassName = config.theme.instagram;
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(InstagramComponent, {
        className: className,
        instagramClassName: instagramClassName,
        format: this.__format,
        nodeKey: this.getKey(),
        postID: this.__id
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "instagram";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new InstagramNode(node.__id, node.__format, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var node = $createInstagramNode(serializedNode.postID);
      node.setFormat(serializedNode.format);
      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        div: function div(domNode) {
          if (!domNode.hasAttribute("data-lexical-instagram-id")) {
            return null;
          }

          return {
            conversion: convertInstagramElement,
            priority: 2
          };
        }
      };
    }
  }]);

  return InstagramNode;
}(_lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_11__/* .DecoratorBlockNode */ .K);
function $createInstagramNode(postID) {
  return new InstagramNode(postID);
}
function $isInstagramNode(node) {
  return node instanceof InstagramNode;
}

/***/ }),

/***/ 83943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P$": function() { return /* binding */ LineLinkNode; },
/* harmony export */   "wr": function() { return /* binding */ $createLineLinkNode; }
/* harmony export */ });
/* unused harmony export $isLineLinkNode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22587);
/* harmony import */ var _lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25968);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







// importで画像を読み込むと、nest-imagesの設定の関係でbase64化されてしまうため
// publicディレクトリから読み込む
var iconLinePath = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/main/images/icons/line.svg");

function LineLinkComponent(_ref) {
  var className = _ref.className,
      lineLinkClassName = _ref.lineLinkClassName,
      format = _ref.format,
      nodeKey = _ref.nodeKey,
      url = _ref.url,
      buttonText = _ref.buttonText,
      promotionText = _ref.promotionText;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_6__/* .BlockWithAlignableContents */ .U, {
    className: className,
    format: format,
    nodeKey: nodeKey,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      className: lineLinkClassName,
      children: [promotionText && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: "promotion",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
          className: "promotion-text",
          children: promotionText
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
        className: "button line-add-friend",
        href: url,
        target: "_blank",
        "data-event-category": "LINE Add",
        "data-event-label": "Article Button01",
        rel: "noopener noreferrer",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
          className: "inner",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
            className: "symbol",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
              src: iconLinePath,
              alt: "LINE"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
            className: "text",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
              children: buttonText
            })
          })]
        })
      })]
    })
  });
}

var LineLinkNode = /*#__PURE__*/function (_DecoratorBlockNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(LineLinkNode, _DecoratorBlockNode);

  var _super = _createSuper(LineLinkNode);

  function LineLinkNode(url, buttonText, promotionText, format, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, LineLinkNode);

    _this = _super.call(this, format, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_this), "__url", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_this), "__buttonText", void 0);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_this), "__promotionText", void 0);

    _this.__url = url;
    _this.__buttonText = buttonText;
    _this.__promotionText = promotionText || null;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(LineLinkNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LineLinkNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "lineLink",
        version: 1,
        url: this.__url,
        buttonText: this.__buttonText,
        promotionText: this.__promotionText
      });
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("div");
      var link = document.createElement("a");
      var linkInner = document.createElement("div");
      var symbolBlock = document.createElement("div");
      var symbolImage = document.createElement("img");
      var textBlock = document.createElement("div");
      var text = document.createElement("span");
      var promotionBlock = document.createElement("div");
      var promotionText = document.createElement("div");
      var theme = editor._config.theme;
      var className = theme.lineLink;

      if (className !== undefined) {
        element.className = className;
      }

      link.href = this.__url;
      link.target = "_blank";
      link.className = "button line-add-friend";
      linkInner.className = "inner";
      symbolImage.src = iconLinePath;
      symbolImage.alt = "LINE";
      symbolBlock.className = "symbol";
      symbolBlock.appendChild(symbolImage);

      if (this.__promotionText) {
        promotionBlock.className = "promotion";
        promotionText.className = "promotion-text";
        promotionText.textContent = this.__promotionText;
        promotionBlock.appendChild(promotionText);
      }

      textBlock.className = "text";
      text.textContent = this.__buttonText;
      textBlock.appendChild(text);
      linkInner.appendChild(symbolBlock);
      linkInner.appendChild(textBlock);
      link.appendChild(linkInner);
      element.appendChild(promotionBlock);
      element.appendChild(link);
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent(_includeInert, _includeDirectionless) {
      var text = this.__promotionText ? "".concat(this.__promotionText, "\n") : "";
      text = "".concat(text, "[LINE]").concat(this.__buttonText, "\n").concat(this.__url);
      return text;
    }
  }, {
    key: "decorate",
    value: function decorate(_editor, config) {
      var embedBlockTheme = config.theme.embedBlock || {};
      var className = {
        base: embedBlockTheme.base || "",
        focus: embedBlockTheme.focus || ""
      };
      var lineLinkClassName = config.theme.lineLink;
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LineLinkComponent, {
        className: className,
        lineLinkClassName: lineLinkClassName,
        format: this.__format,
        nodeKey: this.getKey(),
        url: this.__url,
        buttonText: this.__buttonText,
        promotionText: this.__promotionText
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "lineLink";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new LineLinkNode(node.__url, node.__buttonText, node.__promotionText, node.__format, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var url = serializedNode.url,
          buttonText = serializedNode.buttonText,
          promotionText = serializedNode.promotionText;
      var node = $createLineLinkNode({
        url: url,
        buttonText: buttonText,
        promotionText: promotionText
      });
      node.setFormat(serializedNode.format);
      return node;
    }
  }]);

  return LineLinkNode;
}(_lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_12__/* .DecoratorBlockNode */ .K);
function $createLineLinkNode(_ref2) {
  var url = _ref2.url,
      buttonText = _ref2.buttonText,
      promotionText = _ref2.promotionText;
  return new LineLinkNode(url, buttonText, promotionText);
}
function $isLineLinkNode(node) {
  return node instanceof LineLinkNode;
}

/***/ }),

/***/ 421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jt": function() { return /* binding */ $createSearchFormNode; },
  "sc": function() { return /* binding */ SearchFormNode; }
});

// UNUSED EXPORTS: $isSearchFormNode

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js + 1 modules
var get = __webpack_require__(74450);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalBlockWithAlignableContents.prod.mjs
var LexicalBlockWithAlignableContents_prod = __webpack_require__(22587);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalDecoratorBlockNode.prod.mjs
var LexicalDecoratorBlockNode_prod = __webpack_require__(57729);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/constants/SearchCategories.ts
var SearchCategories = __webpack_require__(80264);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchHotel.tsx + 1 modules
var SearchHotel = __webpack_require__(10252);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchFlight.tsx + 1 modules
var SearchFlight = __webpack_require__(80700);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchDynamicPackage.tsx + 1 modules
var SearchDynamicPackage = __webpack_require__(35047);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 2 modules
var store = __webpack_require__(62394);
// EXTERNAL MODULE: ./main/javascripts/features/search/searchPageSlice.ts
var searchPageSlice = __webpack_require__(54231);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/features/post/postSlice.ts
var postSlice = __webpack_require__(78121);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/InPostSearchCategoryTab.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var InPostSearchCategoryTab = function InPostSearchCategoryTab(props) {
  var _post$searchTypes;

  var _props$borderStyleKey = props.borderStyleKey,
      borderStyleKey = _props$borderStyleKey === void 0 ? "default" : _props$borderStyleKey;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var post = (0,store/* useAppSelector */.CG)(postSlice/* postSelector */.pm);
  var searchCategory = (0,store/* useAppSelector */.CG)(searchPageSlice/* searchCategorySelector */.el);

  var onClickHotel = function onClickHotel() {
    appDispatch((0,searchPageSlice/* changeSearchCategory */.xc)(SearchCategories/* searchCategories.hotel */.M.hotel));
  };

  var onClickFlight = function onClickFlight() {
    appDispatch((0,searchPageSlice/* changeSearchCategory */.xc)(SearchCategories/* searchCategories.flight */.M.flight));
  };

  var onClickDynamicPackage = function onClickDynamicPackage() {
    appDispatch((0,searchPageSlice/* changeSearchCategory */.xc)(SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage));
  };

  var hotel = SearchCategories/* searchCategories.hotel */.M.hotel,
      flight = SearchCategories/* searchCategories.flight */.M.flight,
      dynamicPackage = SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage;

  var renderHotelTab = function renderHotelTab() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: [tabContainerStyle, tabHotelStyle,  true ? "" : 0,  true ? "" : 0],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        onClick: onClickHotel,
        css: [tabStyle, searchCategory === hotel ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: iconStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "hotel"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: labelStyle,
          children: t("search.hotel")
        })]
      })
    }, SearchCategories/* searchCategories.hotel */.M.hotel);
  };

  var renderFlightTab = function renderFlightTab() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: [tabContainerStyle, tabFlightStyle,  true ? "" : 0,  true ? "" : 0],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        onClick: onClickFlight,
        css: [tabStyle, searchCategory === flight ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: iconStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "airplane"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: labelStyle,
          children: t("search.flight")
        })]
      })
    }, SearchCategories/* searchCategories.flight */.M.flight);
  };

  var renderDynamicPackageTab = function renderDynamicPackageTab() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: [tabContainerStyle, tabDynamicPackageStyle,  true ? "" : 0,  true ? "" : 0],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        onClick: onClickDynamicPackage,
        css: [tabStyle, searchCategory === dynamicPackage ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: iconStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "airplane"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: verticalMiddleStyle,
            children: "+"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: [iconStyle, iconMultiStyle,  true ? "" : 0,  true ? "" : 0],
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "hotel"
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
          css: labelStyle,
          children: [t("search.flight"), " + ", t("search.hotel")]
        })]
      })
    }, SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: [innerStyle, InPostSearchCategoryTab_borderStyle[borderStyleKey],  true ? "" : 0,  true ? "" : 0],
      children: (_post$searchTypes = post.searchTypes) === null || _post$searchTypes === void 0 ? void 0 : _post$searchTypes.map(function (searchType) {
        var camelizedSearchType = (0,humps.camelize)(searchType);

        if (camelizedSearchType === SearchCategories/* searchCategories.hotel */.M.hotel) {
          return renderHotelTab();
        } else if (camelizedSearchType === SearchCategories/* searchCategories.flight */.M.flight) {
          return renderFlightTab();
        } else if (camelizedSearchType === SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage) {
          return renderDynamicPackageTab();
        }

        return;
      })
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var innerStyle =  true ? {
  name: "andpxo",
  styles: "display:flex;overflow:hidden"
} : 0;
var tabContainerStyle =  true ? {
  name: "17pxs3y",
  styles: "box-sizing:border-box;overflow:hidden;width:auto"
} : 0;
var tabHotelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:33.333%;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:auto;}" + ( true ? "" : 0),  true ? "" : 0);
var tabFlightStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:33.333%;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:auto;}" + ( true ? "" : 0),  true ? "" : 0);
var tabDynamicPackageStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:33.333%;min-width:120px;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:auto;}" + ( true ? "" : 0),  true ? "" : 0);
var tabStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;cursor:pointer;display:flex;flex-direction:column;justify-content:center;padding:0 0.1rem 1px;font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";text-align:center;height:44px;color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";box-sizing:border-box;background-color:#fff;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 1rem 1px;flex-direction:row;align-items:center;height:38px;line-height:41px;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";}" + ( true ? "" : 0),  true ? "" : 0);
var tabSelectedStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("&:after{content:\"\";position:absolute;bottom:0;left:0;display:block;width:100%;height:2px;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:inline-block;i{font-size:1.125rem;vertical-align:middle;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{position:relative;top:-1px;}}" + ( true ? "" : 0),  true ? "" : 0);
var iconMultiStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("i{padding-left:0.25rem;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding-left:0.25rem;}}" + ( true ? "" : 0),  true ? "" : 0);
var labelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("vertical-align:middle;padding-top:0.2rem;line-height:1;display:block;font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding-top:0;padding-left:", spaceStyle/* space.atom */.D.atom, ";display:inline;line-height:41px;}" + ( true ? "" : 0),  true ? "" : 0);
var verticalMiddleStyle =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;
var InPostSearchCategoryTab_borderStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{border-radius:0;}" + ( true ? "" : 0),  true ? "" : 0),
  noRound:  true ? {
    name: "1ch9yvl",
    styles: "border-radius:0"
  } : 0
};
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/InPostSearchForm.tsx
function InPostSearchForm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var InPostSearchForm = function InPostSearchForm() {
  var searchCategory = (0,store/* useAppSelector */.CG)(searchPageSlice/* searchCategorySelector */.el);
  var post = (0,store/* useAppSelector */.CG)(postSlice/* postSelector */.pm);

  var renderSearchType = function renderSearchType() {
    switch (searchCategory) {
      case SearchCategories/* searchCategories.hotel */.M.hotel:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotel/* SearchHotel */.y, {
          isCompact: true
        });

      case SearchCategories/* searchCategories.flight */.M.flight:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFlight/* SearchFlight */.Z, {
          isCompact: true
        });

      case SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchDynamicPackage/* SearchDynamicPackage */.D, {
          isCompact: true
        });

      default:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotel/* SearchHotel */.y, {
          isCompact: true
        });
    }
  };

  if (!post.searchTypes || post.searchTypes.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: InPostSearchForm_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: InPostSearchForm_innerStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: categoryTabStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InPostSearchCategoryTab, {
          borderStyleKey: "noRound"
        })
      }), renderSearchType()]
    })
  });
};
var InPostSearchForm_blockStyle =  true ? {
  name: "1m20o2a",
  styles: "max-width:500px;margin:0 auto 0"
} : 0;
var InPostSearchForm_innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-radius:10px;border:1px solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";box-shadow:0 0.125rem 1rem ", colorStyle/* shadowColor.soft */.nm.soft, ";overflow:hidden;" + ( true ? "" : 0),  true ? "" : 0);
var categoryTabStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-bottom:1px solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalComposerContext.prod.mjs
var LexicalComposerContext_prod = __webpack_require__(46895);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/nodes/SearchFormMock.tsx




 // react final formのform配下でのみ使用できる



function SearchFormMock() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var _useField = (0,react_final_form_es/* useField */.U$)("search_types"),
      searchTypesValue = _useField.input.value;

  var renderCategoryText = function renderCategoryText(category) {
    var camelizedSearchType = (0,humps.camelize)(category);

    if (camelizedSearchType === SearchCategories/* searchCategories.hotel */.M.hotel) {
      return t("search.hotel");
    } else if (camelizedSearchType === SearchCategories/* searchCategories.flight */.M.flight) {
      return t("search.flight");
    } else if (camelizedSearchType === SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage) {
      return "".concat(t("search.flight"), " + ").concat(t("search.hotel"));
    }
  };

  var renderTabs = function renderTabs() {
    if (searchTypesValue && searchTypesValue.length > 0) {
      return searchTypesValue.map(function (category) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "tab",
            children: renderCategoryText(category)
          })
        }, category);
      });
    } else {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "tab"
        })
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: "mock",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "inner",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "category-tab",
        children: renderTabs()
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "form-block"
      })]
    })
  });
}
;// CONCATENATED MODULE: ./main/javascripts/components/editor/nodes/SearchFormNode.tsx









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









function SearchFormComponent(_ref) {
  var className = _ref.className,
      searchFormClassName = _ref.searchFormClassName,
      format = _ref.format,
      nodeKey = _ref.nodeKey;

  var _useLexicalComposerCo = (0,LexicalComposerContext_prod/* useLexicalComposerContext */.g)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LexicalBlockWithAlignableContents_prod/* BlockWithAlignableContents */.U, {
    className: className,
    format: format,
    nodeKey: nodeKey,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: searchFormClassName,
      children: !editor.isEditable() ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InPostSearchForm, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFormMock, {})
    })
  });
}

var SearchFormNode = /*#__PURE__*/function (_DecoratorBlockNode) {
  (0,inherits/* default */.Z)(SearchFormNode, _DecoratorBlockNode);

  var _super = _createSuper(SearchFormNode);

  function SearchFormNode(format, key) {
    (0,classCallCheck/* default */.Z)(this, SearchFormNode);

    return _super.call(this, format, key);
  }

  (0,createClass/* default */.Z)(SearchFormNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SearchFormNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "searchForm",
        version: 1
      });
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("div");
      var mock = document.createElement("div");
      var inner = document.createElement("div");
      var categoryTab = document.createElement("div");
      var tab = document.createElement("div");
      var formBlock = document.createElement("div");
      var theme = editor._config.theme;
      var className = theme.searchForm;

      if (className !== undefined) {
        element.className = className;
      }

      mock.className = "mock";
      inner.className = "inner";
      categoryTab.className = "category-tab";
      tab.className = "tab";
      formBlock.className = "form-block";
      inner.appendChild(categoryTab);
      categoryTab.appendChild(tab);
      inner.appendChild(formBlock);
      mock.appendChild(inner);
      element.appendChild(mock);
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "decorate",
    value: function decorate(_editor, config) {
      var embedBlockTheme = config.theme.embedBlock || {};
      var className = {
        base: embedBlockTheme.base || "",
        focus: embedBlockTheme.focus || ""
      };
      var searchFormClassName = config.theme.searchForm;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFormComponent, {
        className: className,
        searchFormClassName: searchFormClassName,
        format: this.__format,
        nodeKey: this.getKey()
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "searchForm";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new SearchFormNode(node.__format, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var node = $createSearchFormNode();
      node.setFormat(serializedNode.format);
      return node;
    }
  }]);

  return SearchFormNode;
}(LexicalDecoratorBlockNode_prod/* DecoratorBlockNode */.K);
function $createSearchFormNode() {
  return new SearchFormNode();
}
function $isSearchFormNode(node) {
  return node instanceof SearchFormNode;
}

/***/ }),

/***/ 44855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "je": function() { return /* binding */ TweetNode; },
/* harmony export */   "m2": function() { return /* binding */ $createTweetNode; }
/* harmony export */ });
/* unused harmony export $isTweetNode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22587);
/* harmony import */ var _lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */






var WIDGET_SCRIPT_URL = "https://platform.twitter.com/widgets.js";

function $convertTweetElement(domNode) {
  var id = domNode.getAttribute("data-lexical-tweet-id");

  if (id) {
    var node = $createTweetNode(id);
    return {
      node: node
    };
  }

  return null;
}

var isTwitterScriptLoading = true;

function TweetComponent(_ref) {
  var className = _ref.className,
      tweetClassName = _ref.tweetClassName,
      format = _ref.format,
      loadingComponent = _ref.loadingComponent,
      nodeKey = _ref.nodeKey,
      onError = _ref.onError,
      onLoad = _ref.onLoad,
      tweetID = _ref.tweetID;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
  var previousTweetIDRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      isTweetLoading = _useState[0],
      setIsTweetLoading = _useState[1];

  var createTweet = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/(0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee() {
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return window.twttr.widgets.createTweet(tweetID, containerRef.current);

          case 3:
            setIsTweetLoading(false);
            isTwitterScriptLoading = false;

            if (onLoad) {
              onLoad();
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            if (onError) {
              onError(String(_context.t0));
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  })), [onError, onLoad, tweetID]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    if (tweetID !== previousTweetIDRef.current) {
      setIsTweetLoading(true);
      var twitterScript = document.querySelector("script[src=\"".concat(WIDGET_SCRIPT_URL, "\"]"));

      if (isTwitterScriptLoading && !twitterScript) {
        var _document$body;

        var script = document.createElement("script");
        script.src = WIDGET_SCRIPT_URL;
        script.async = true;
        (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(script);

        script.onload = function () {
          script.setAttribute("data-loaded", "true");
          createTweet();
        };

        if (onError) {
          script.onerror = onError;
        }
      } else {
        if (twitterScript.hasAttribute("data-loaded")) {
          createTweet();
        } else {
          twitterScript.addEventListener("load", function () {
            createTweet();
          });
        }
      }

      if (previousTweetIDRef) {
        previousTweetIDRef.current = tweetID;
      }
    }
  }, [createTweet, onError, tweetID]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_7__/* .BlockWithAlignableContents */ .U, {
    className: className,
    format: format,
    nodeKey: nodeKey,
    children: [isTweetLoading ? loadingComponent : null, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
      className: tweetClassName,
      style: {
        display: "inline-block",
        width: "550px"
      },
      ref: containerRef
    })]
  });
}

var TweetNode = /*#__PURE__*/function (_DecoratorBlockNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(TweetNode, _DecoratorBlockNode);

  var _super = _createSuper(TweetNode);

  function TweetNode(id, format, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, TweetNode);

    _this = _super.call(this, format, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_this), "__id", void 0);

    _this.__id = id;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TweetNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TweetNode.prototype), "exportJSON", this).call(this)), {}, {
        id: this.getId(),
        type: "tweet",
        version: 1
      });
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("div");
      element.setAttribute("data-lexical-tweet-id", this.__id);
      var theme = editor._config.theme;
      var className = theme.tweet;

      if (className !== undefined) {
        element.className = className;
      }

      return {
        element: element
      };
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.__id;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent(_includeInert, _includeDirectionless) {
      return "https://x.com/i/web/status/".concat(this.__id);
    }
  }, {
    key: "decorate",
    value: function decorate(editor, config) {
      var embedBlockTheme = config.theme.embedBlock || {};
      var className = {
        base: embedBlockTheme.base || "",
        focus: embedBlockTheme.focus || ""
      };
      var tweetClassName = config.theme.tweet;
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(TweetComponent, {
        className: className,
        tweetClassName: tweetClassName,
        format: this.__format,
        loadingComponent: "Loading...",
        nodeKey: this.getKey(),
        tweetID: this.__id
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "tweet";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new TweetNode(node.__id, node.__format, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var node = $createTweetNode(serializedNode.id);
      node.setFormat(serializedNode.format);
      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        div: function div(domNode) {
          if (!domNode.hasAttribute("data-lexical-tweet-id")) {
            return null;
          }

          return {
            conversion: $convertTweetElement,
            priority: 2
          };
        }
      };
    }
  }]);

  return TweetNode;
}(_lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_13__/* .DecoratorBlockNode */ .K);
function $createTweetNode(tweetID) {
  return new TweetNode(tweetID);
}
function $isTweetNode(node) {
  return node instanceof TweetNode;
}

/***/ }),

/***/ 21314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gL": function() { return /* binding */ YouTubeNode; },
/* harmony export */   "kU": function() { return /* binding */ $createYouTubeNode; }
/* harmony export */ });
/* unused harmony export $isYouTubeNode */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92777);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10748);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74450);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22587);
/* harmony import */ var _lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */





function YouTubeComponent(_ref) {
  var className = _ref.className,
      youtubeClassName = _ref.youtubeClassName,
      format = _ref.format,
      nodeKey = _ref.nodeKey,
      videoID = _ref.videoID;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_lexical_react_LexicalBlockWithAlignableContents__WEBPACK_IMPORTED_MODULE_5__/* .BlockWithAlignableContents */ .U, {
    className: className,
    format: format,
    nodeKey: nodeKey,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      className: youtubeClassName,
      style: {
        display: "inline-block"
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("iframe", {
          width: "560",
          height: "315",
          src: "https://www.youtube-nocookie.com/embed/".concat(videoID),
          frameBorder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowFullScreen: true,
          title: "YouTube video"
        })
      })
    })
  });
}

function $convertYoutubeElement(domNode) {
  var videoID = domNode.getAttribute("data-lexical-youtube");

  if (videoID) {
    var node = $createYouTubeNode(videoID);
    return {
      node: node
    };
  }

  return null;
}

var YouTubeNode = /*#__PURE__*/function (_DecoratorBlockNode) {
  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(YouTubeNode, _DecoratorBlockNode);

  var _super = _createSuper(YouTubeNode);

  function YouTubeNode(id, format, key) {
    var _this;

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, YouTubeNode);

    _this = _super.call(this, format, key);

    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this), "__id", void 0);

    _this.__id = id;
    return _this;
  }

  (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(YouTubeNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_get_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(YouTubeNode.prototype), "exportJSON", this).call(this)), {}, {
        type: "youtube",
        version: 1,
        videoID: this.__id
      });
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(editor) {
      var element = document.createElement("div");
      var inner = document.createElement("div");
      var iframe = document.createElement("iframe");
      var theme = editor._config.theme;
      var className = theme.youTube;

      if (className !== undefined) {
        element.className = className;
      }

      iframe.src = "https://www.youtube-nocookie.com/embed/".concat(this.__id);
      iframe.setAttribute("loading", "lazy");
      iframe.width = "560";
      iframe.height = "315";
      iframe.frameBorder = "0";
      iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.title = "YouTube video";
      inner.appendChild(iframe);
      element.appendChild(inner);
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.__id;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent(_includeInert, _includeDirectionless) {
      return "https://www.youtube.com/watch?v=".concat(this.__id);
    }
  }, {
    key: "decorate",
    value: function decorate(_editor, config) {
      var embedBlockTheme = config.theme.embedBlock || {};
      var className = {
        base: embedBlockTheme.base || "",
        focus: embedBlockTheme.focus || ""
      };
      var youtubeClassName = config.theme.youTube;
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(YouTubeComponent, {
        className: className,
        youtubeClassName: youtubeClassName,
        format: this.__format,
        nodeKey: this.getKey(),
        videoID: this.__id
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "youtube";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new YouTubeNode(node.__id, node.__format, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var node = $createYouTubeNode(serializedNode.videoID);
      node.setFormat(serializedNode.format);
      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        iframe: function iframe(domNode) {
          if (!domNode.hasAttribute("data-lexical-youtube")) {
            return null;
          }

          return {
            conversion: $convertYoutubeElement,
            priority: 1
          };
        }
      };
    }
  }]);

  return YouTubeNode;
}(_lexical_react_LexicalDecoratorBlockNode__WEBPACK_IMPORTED_MODULE_11__/* .DecoratorBlockNode */ .K);
function $createYouTubeNode(videoID) {
  return new YouTubeNode(videoID);
}
function $isYouTubeNode(node) {
  return node instanceof YouTubeNode;
}

/***/ }),

/***/ 55789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CodeHighlightPlugin; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16835);
/* harmony import */ var _lexical_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87012);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46895);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



function CodeHighlightPlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_1__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return (0,_lexical_code__WEBPACK_IMPORTED_MODULE_3__/* .registerCodeHighlighting */ .dM)(editor);
  }, [editor]);
  return null;
}

/***/ }),

/***/ 99317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CustomTablePlugin; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27812);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16835);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46895);
/* harmony import */ var _lexical_table__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79380);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _shared_invariant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36024);
/* harmony import */ var _nodes_CustomTableNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52919);
/* harmony import */ var _nodes_CustomTableBlockNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39541);
/* harmony import */ var _nodes_CustomTableInnerNode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12292);
/* harmony import */ var _themes_Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35384);



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// 記事詳細でスマホ幅の場合にテーブルをスクロールできるようにする
// https://github.com/NinNinInc/tabi/pull/2335
// https://github.com/NinNinInc/tabi/issues/2321
// に対応するためにカスタムプラグインで対応










function CustomTablePlugin(_ref) {
  var _ref$hasCellMerge = _ref.hasCellMerge,
      hasCellMerge = _ref$hasCellMerge === void 0 ? true : _ref$hasCellMerge,
      _ref$hasCellBackgroun = _ref.hasCellBackgroundColor,
      hasCellBackgroundColor = _ref$hasCellBackgroun === void 0 ? true : _ref$hasCellBackgroun,
      _ref$hasTabHandler = _ref.hasTabHandler,
      hasTabHandler = _ref$hasTabHandler === void 0 ? true : _ref$hasTabHandler;

  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_5__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  var scrollableTables = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableNode */ .Fh, _lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableCellNode */ .Cr, _lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableRowNode */ .g0])) {
      (0,_shared_invariant__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(false, "TablePlugin: TableNode, TableCellNode or TableRowNode not registered on editor");
    }

    return (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .mergeRegister */ .qV)(editor.registerCommand(_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .INSERT_TABLE_COMMAND */ .bF, function (_ref2) {
      var columns = _ref2.columns,
          rows = _ref2.rows,
          includeHeaders = _ref2.includeHeaders;
      var tableNode = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$createTableNodeWithDimensions */ .uv)(Number(rows), Number(columns), includeHeaders);
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$insertNodeToNearestRoot */ .z8)(tableNode);
      var firstDescendant = tableNode.getFirstDescendant();

      if ((0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$isTextNode */ .Gg)(firstDescendant)) {
        firstDescendant.select();
      }

      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_10__/* .COMMAND_PRIORITY_EDITOR */ .VN), editor.registerNodeTransform(_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableNode */ .Fh, function (node) {
      var _$computeTableMapSkip = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$computeTableMapSkipCellCheck */ .CS)(node, null, null),
          _$computeTableMapSkip2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_$computeTableMapSkip, 1),
          gridMap = _$computeTableMapSkip2[0];

      var maxRowLength = gridMap.reduce(function (curLength, row) {
        return Math.max(curLength, row.length);
      }, 0);

      for (var i = 0; i < gridMap.length; ++i) {
        var rowLength = gridMap[i].length;

        if (rowLength === maxRowLength) {
          continue;
        }

        var lastCellMap = gridMap[i][rowLength - 1];
        var lastRowCell = lastCellMap.cell;

        for (var j = rowLength; j < maxRowLength; ++j) {
          // TODO: inherit header state from another header or body
          var newCell = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$createTableCellNode */ .ku)(0);
          newCell.append((0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$createParagraphNode */ .BE)());

          if (lastRowCell !== null) {
            lastRowCell.insertAfter(newCell);
          } else {
            (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$insertFirst */ .bV)(lastRowCell, newCell);
          }
        }
      }
    }));
  }, [editor]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var tableSelections = new Map();

    var initializeTableNode = function initializeTableNode(tableNode) {
      var nodeKey = tableNode.getKey();
      var tableElement = editor.getElementByKey(nodeKey);

      if (tableElement && !tableSelections.has(nodeKey)) {
        var tableSelection = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .applyTableHandlers */ .rN)(tableNode, tableElement, editor, hasTabHandler);
        tableSelections.set(nodeKey, tableSelection);
      }
    }; // Plugins might be loaded _after_ initial content is set, hence existing table nodes
    // won't be initialized from mutation[create] listener. Instead doing it here,


    editor.getEditorState().read(function () {
      var tableNodes = (0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$nodesOfType */ .K8)(_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableNode */ .Fh);
      tableNodes.concat((0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$nodesOfType */ .K8)(_nodes_CustomTableNode__WEBPACK_IMPORTED_MODULE_1__/* .CustomTableNode */ .w));

      var _iterator = _createForOfIteratorHelper(tableNodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tableNode = _step.value;

          if ((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableNode */ .di)(tableNode)) {
            initializeTableNode(tableNode);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    var unregisterMutationListener = editor.registerMutationListener(_nodes_CustomTableNode__WEBPACK_IMPORTED_MODULE_1__/* .CustomTableNode */ .w, function (nodeMutations) {
      var _iterator2 = _createForOfIteratorHelper(nodeMutations),
          _step2;

      try {
        var _loop = function _loop() {
          var _step2$value = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_step2.value, 2),
              nodeKey = _step2$value[0],
              mutation = _step2$value[1];

          // Nodeがoverrideでreplaceされるとupdatedが発火するので再登録する
          if (mutation === "created" || mutation === "updated") {
            editor.getEditorState().read(function () {
              var tableNode = (0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$getNodeByKey */ .gI)(nodeKey);

              if ((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableNode */ .di)(tableNode)) {
                initializeTableNode(tableNode);
              }
            });
          } else if (mutation === "destroyed") {
            var tableSelection = tableSelections.get(nodeKey);

            if (tableSelection !== undefined) {
              tableSelection.removeListeners();
              tableSelections["delete"](nodeKey);
            }
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    return function () {
      unregisterMutationListener(); // Hook might be called multiple times so cleaning up tables listeners as well,
      // as it'll be reinitialized during recurring call

      var _iterator3 = _createForOfIteratorHelper(tableSelections),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_step3.value, 2),
              tableSelection = _step3$value[1];

          tableSelection.removeListeners();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
  }, [editor, hasTabHandler]); // Unmerge cells when the feature isn't enabled

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (hasCellMerge) {
      return;
    }

    return editor.registerNodeTransform(_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableCellNode */ .Cr, function (node) {
      if (node.getColSpan() > 1 || node.getRowSpan() > 1) {
        // When we have rowSpan we have to map the entire Table to understand where the new Cells
        // fit best; let's analyze all Cells at once to save us from further transform iterations
        var _$getNodeTriplet = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$getNodeTriplet */ .$r)(node),
            _$getNodeTriplet2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_$getNodeTriplet, 3),
            gridNode = _$getNodeTriplet2[2];

        var _$computeTableMap = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$computeTableMap */ .kr)(gridNode, node, node),
            _$computeTableMap2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_$computeTableMap, 1),
            gridMap = _$computeTableMap2[0]; // TODO this function expects Tables to be normalized. Look into this once it exists


        var rowsCount = gridMap.length;
        var columnsCount = gridMap[0].length;
        var row = gridNode.getFirstChild();
        (0,_shared_invariant__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableRowNode */ .to)(row), "Expected TableNode first child to be a RowNode");
        var unmerged = [];

        for (var i = 0; i < rowsCount; i++) {
          if (i !== 0) {
            row = row.getNextSibling();
            (0,_shared_invariant__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableRowNode */ .to)(row), "Expected TableNode first child to be a RowNode");
          }

          var lastRowCell = null;

          for (var j = 0; j < columnsCount; j++) {
            var cellMap = gridMap[i][j];
            var cell = cellMap.cell;

            if (cellMap.startRow === i && cellMap.startColumn === j) {
              lastRowCell = cell;
              unmerged.push(cell);
            } else if (cell.getColSpan() > 1 || cell.getRowSpan() > 1) {
              (0,_shared_invariant__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableCellNode */ .TF)(cell), "Expected TableNode cell to be a TableCellNode");
              var newCell = (0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$createTableCellNode */ .ku)(cell.__headerState);

              if (lastRowCell !== null) {
                lastRowCell.insertAfter(newCell);
              } else {
                (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$insertFirst */ .bV)(row, newCell);
              }
            }
          }
        }

        for (var _i = 0, _unmerged = unmerged; _i < _unmerged.length; _i++) {
          var _cell = _unmerged[_i];

          _cell.setColSpan(1);

          _cell.setRowSpan(1);
        }
      }
    });
  }, [editor, hasCellMerge]); // Remove cell background color when feature is disabled

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (hasCellBackgroundColor) {
      return;
    }

    return editor.registerNodeTransform(_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .TableCellNode */ .Cr, function (node) {
      if (node.getBackgroundColor() !== null) {
        node.setBackgroundColor(null);
      }
    });
  }, [editor, hasCellBackgroundColor, hasCellMerge]); // Read Modeの時だけラッパー用のNodeを追加して
  // 横スクロール用の処理をする

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.isEditable()) {
      editor.update(function () {
        var tableNodes = (0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$nodesOfType */ .K8)(_nodes_CustomTableNode__WEBPACK_IMPORTED_MODULE_1__/* .CustomTableNode */ .w);

        var _iterator4 = _createForOfIteratorHelper(tableNodes),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var tableNode = _step4.value;

            if ((0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableNode */ .di)(tableNode)) {
              (function () {
                var firstRow = tableNode.getFirstChildOrThrow();

                if (!(0,_lexical_table__WEBPACK_IMPORTED_MODULE_7__/* .$isTableRowNode */ .to)(firstRow)) {
                  throw new Error("Expected to find row node.");
                }

                var colCount = firstRow.getChildrenSize();
                var isScrollable = colCount >= 4;
                tableNode.setIsScrollable(isScrollable);
                var tableInnerNode = (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$wrapNodeInElement */ .JB)(tableNode, _nodes_CustomTableInnerNode__WEBPACK_IMPORTED_MODULE_3__/* .$createTableInnerNode */ .z);

                var createTableBlockNode = function createTableBlockNode() {
                  return (0,_nodes_CustomTableBlockNode__WEBPACK_IMPORTED_MODULE_2__/* .$createTableBlockNode */ .k)(isScrollable);
                };

                (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_9__/* .$wrapNodeInElement */ .JB)(tableInnerNode, createTableBlockNode);
              })();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      });
      editor.registerUpdateListener(function (_ref3) {
        var editorState = _ref3.editorState;

        if (scrollableTables.current && scrollableTables.current.length > 0) {
          return;
        }

        editorState.read(function () {
          var tableBlockNodes = (0,lexical__WEBPACK_IMPORTED_MODULE_10__/* .$nodesOfType */ .K8)(_nodes_CustomTableBlockNode__WEBPACK_IMPORTED_MODULE_2__/* .CustomTableBlockNode */ .v);

          if (!tableBlockNodes || tableBlockNodes.length === 0) {
            return;
          }

          var _iterator5 = _createForOfIteratorHelper(tableBlockNodes),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var tableBlockNode = _step5.value;

              if (tableBlockNode.getIsScrollable()) {
                var element = editor.getElementByKey(tableBlockNode.getKey());

                if (element) {
                  scrollableTables.current.push(element);
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          setTableScrollStyles();
          window.addEventListener("resize", onResizeWindow);
        });
      });
    }

    return function () {
      if (!editor.isEditable()) {
        unsetTableScrollStyles();
        window.removeEventListener("resize", onResizeWindow);
      }
    };
  }, []);

  var onResizeWindow = function onResizeWindow() {
    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(scrollableTables.current).map(function (table) {
      var innerElement = table.querySelector(".".concat(_themes_Theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tableBlockInner */ .Z.tableBlockInner));

      if (innerElement) {
        updateTableScrollStyle(innerElement);
      }
    });
  };

  var setTableScrollStyles = function setTableScrollStyles() {
    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(scrollableTables.current).map(function (table) {
      var innerElement = table.querySelector(".".concat(_themes_Theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tableBlockInner */ .Z.tableBlockInner));

      if (innerElement) {
        innerElement.addEventListener("scroll", handleScrollEvent);
        updateTableScrollStyle(innerElement);
      }
    });
  };

  var unsetTableScrollStyles = function unsetTableScrollStyles() {
    (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(scrollableTables.current).map(function (table) {
      var innerElement = table.querySelector(".".concat(_themes_Theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tableBlockInner */ .Z.tableBlockInner));

      if (innerElement) {
        innerElement.removeEventListener("scroll", handleScrollEvent);
      }
    });
  };

  var handleScrollEvent = function handleScrollEvent(e) {
    var target = e.target;
    updateTableScrollStyle(target);
  };

  var updateTableScrollStyle = function updateTableScrollStyle(target) {
    var startClass = "scroll--start";
    var endClass = "scroll--end";
    var parent = target.parentElement;

    if (parent.classList.contains(".".concat(_themes_Theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tableBlockScrollable */ .Z.tableBlockScrollable))) {
      return;
    }

    var scrollPos = target.scrollLeft;
    var totalScrolledWidth = target.scrollLeft + target.clientWidth;

    if (scrollPos <= 0) {
      parent.classList.add(endClass);
      parent.classList.remove(startClass);
    } else if (scrollPos > 0) {
      parent.classList.add(startClass);

      if (totalScrolledWidth >= target.scrollWidth - 1) {
        parent.classList.remove(endClass);
      } else {
        parent.classList.add(endClass);
      }
    }
  };

  return null;
}

/***/ }),

/***/ 87814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mo": function() { return /* binding */ INSERT_IMAGE_COMMAND; },
  "fV": function() { return /* binding */ InsertImageDialog; },
  "ZP": function() { return /* binding */ ImagesPlugin; }
});

// UNUSED EXPORTS: InsertImageUploadedDialogBody, InsertImageUriDialogBody

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalComposerContext.prod.mjs
var LexicalComposerContext_prod = __webpack_require__(46895);
// EXTERNAL MODULE: ./node_modules/@lexical/utils/LexicalUtils.prod.mjs
var LexicalUtils_prod = __webpack_require__(18824);
// EXTERNAL MODULE: ./node_modules/lexical/Lexical.prod.mjs
var Lexical_prod = __webpack_require__(61084);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/components/editor/shared/canUseDOM.ts
var canUseDOM = __webpack_require__(56693);
// EXTERNAL MODULE: ./main/javascripts/components/editor/nodes/ImageNode.tsx
var ImageNode = __webpack_require__(25478);
// EXTERNAL MODULE: ./main/javascripts/components/editor/ui/Button.tsx + 1 modules
var Button = __webpack_require__(71137);
// EXTERNAL MODULE: ./main/javascripts/components/editor/ui/Dialog.tsx
var Dialog = __webpack_require__(57596);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/ui/FileInput.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// import './Input.css';




function FileInput(_ref) {
  var accept = _ref.accept,
      label = _ref.label,
      _onChange = _ref.onChange,
      dataTestId = _ref["data-test-id"];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: "Input__wrapper",
    css: fileInputStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
      className: "Input__label",
      children: label
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
      type: "file",
      accept: accept,
      className: "Input__input",
      onChange: function onChange(e) {
        return _onChange(e.target.files);
      },
      "data-test-id": dataTestId
    })]
  });
}
var fileInputStyle =  true ? {
  name: "1n1f4ln",
  styles: "display:flex;flex-direction:row;align-items:center;margin-bottom:10px;.Input__label{display:flex;flex:1;color:#666;}.Input__input{display:flex;flex:2;border:1px solid #999;padding-top:7px;padding-bottom:7px;padding-left:10px;padding-right:10px;font-size:16px;border-radius:5px;min-width:0;}"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/components/editor/ui/TextInput.tsx
var TextInput = __webpack_require__(6528);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/plugins/ImagesPlugin.tsx


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */





 // import landscapeImage from '../../images/landscape.jpg';
// import yellowFlowerImage from '../../images/yellow-flower.jpg';











var getDOMSelection = function getDOMSelection(targetWindow) {
  return canUseDOM/* CAN_USE_DOM */.T ? (targetWindow || window).getSelection() : null;
};

var INSERT_IMAGE_COMMAND = (0,Lexical_prod/* createCommand */.fA)("INSERT_IMAGE_COMMAND");
function InsertImageUriDialogBody(_ref) {
  var _onClick = _ref.onClick;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component", "button"]),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(""),
      src = _useState[0],
      setSrc = _useState[1];

  var _useState2 = (0,react.useState)(""),
      altText = _useState2[0],
      setAltText = _useState2[1];

  var isDisabled = src === "";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* default */.Z, {
      label: t("cms.imageUrl"),
      placeholder: "i.e. https://source.unsplash.com/random",
      onChange: setSrc,
      value: src,
      "data-test-id": "image-modal-url-input"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* default */.Z, {
      label: t("cms.altText"),
      placeholder: t("cms.altTextPlaceholder"),
      onChange: setAltText,
      value: altText,
      "data-test-id": "image-modal-alt-text-input"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* DialogActions */.k, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        "data-test-id": "image-modal-confirm-btn",
        disabled: isDisabled,
        onClick: function onClick() {
          return _onClick({
            altText: altText,
            src: src
          });
        },
        children: t("button:common.add")
      })
    })]
  });
}
function InsertImageUploadedDialogBody(_ref2) {
  var _onClick2 = _ref2.onClick,
      postImage = _ref2.postImage;

  var _useTranslation2 = (0,useTranslation/* useTranslation */.$)(["component", "button"]),
      t = _useTranslation2.t;

  var _useState3 = (0,react.useState)(""),
      src = _useState3[0],
      setSrc = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      altText = _useState4[0],
      setAltText = _useState4[1];

  var isDisabled = src === ""; // const loadImage = (files: FileList | null) => {
  //   const reader = new FileReader();
  //   reader.onload = function () {
  //     if (typeof reader.result === "string") {
  //       setSrc(reader.result);
  //     }
  //     return "";
  //   };
  //   if (files !== null) {
  //     reader.readAsDataURL(files[0]);
  //   }
  // };

  var uploadImage = function uploadImage(files) {
    if (!files || files.length == 0) {
      return;
    }

    var file = files[0];
    postImage(file, {
      name: file.name
    }).then(function (res) {
      setSrc(res.data.url);
    })["catch"](function () {
      console.log("error");
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileInput, {
      label: t("cms.imageUpload"),
      onChange: uploadImage,
      accept: "image/*",
      "data-test-id": "image-modal-file-upload"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* default */.Z, {
      label: t("cms.altText"),
      placeholder: t("cms.altTextPlaceholder"),
      onChange: setAltText,
      value: altText,
      "data-test-id": "image-modal-alt-text-input"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* DialogActions */.k, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        "data-test-id": "image-modal-file-upload-btn",
        disabled: isDisabled,
        onClick: function onClick() {
          return _onClick2({
            altText: altText,
            src: src
          });
        },
        children: t("button:common.add")
      })
    })]
  });
}
function InsertImageDialog(_ref3) {
  var activeEditor = _ref3.activeEditor,
      onClose = _ref3.onClose,
      postImage = _ref3.postImage;

  var _useState5 = (0,react.useState)(null),
      mode = _useState5[0],
      setMode = _useState5[1];

  var hasModifier = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    hasModifier.current = false;

    var handler = function handler(e) {
      hasModifier.current = e.altKey;
    };

    document.addEventListener("keydown", handler);
    return function () {
      document.removeEventListener("keydown", handler);
    };
  }, [activeEditor]);

  var onClick = function onClick(payload) {
    activeEditor.dispatchCommand(INSERT_IMAGE_COMMAND, payload);
    onClose();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [!mode && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dialog/* DialogButtonsList */.a, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        "data-test-id": "image-modal-option-url",
        onClick: function onClick() {
          return setMode("url");
        },
        children: "URL"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        "data-test-id": "image-modal-option-file",
        onClick: function onClick() {
          return setMode("file");
        },
        children: "File"
      })]
    }), mode === "url" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertImageUriDialogBody, {
      onClick: onClick
    }), mode === "file" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InsertImageUploadedDialogBody, {
      onClick: onClick,
      postImage: postImage
    })]
  });
}
function ImagesPlugin(_ref4) {
  var captionsEnabled = _ref4.captionsEnabled;

  var _useLexicalComposerCo = (0,LexicalComposerContext_prod/* useLexicalComposerContext */.g)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react.useEffect)(function () {
    if (!editor.hasNodes([ImageNode/* ImageNode */.HJ])) {
      throw new Error("ImagesPlugin: ImageNode not registered on editor");
    }

    return (0,LexicalUtils_prod/* mergeRegister */.qV)(editor.registerCommand(INSERT_IMAGE_COMMAND, function (payload) {
      // YouTubePluginを参考
      // 現在はブロック要素としてトップレベルへの追加のみ対応
      var imageNode = (0,ImageNode/* $createImageNode */.HB)(payload);
      (0,LexicalUtils_prod/* $insertNodeToNearestRoot */.z8)(imageNode);
      return true;
    }, Lexical_prod/* COMMAND_PRIORITY_EDITOR */.VN), editor.registerCommand(Lexical_prod/* DRAGSTART_COMMAND */.XI, function (event) {
      return $onDragStart(event);
    }, Lexical_prod/* COMMAND_PRIORITY_HIGH */.Eo), editor.registerCommand(Lexical_prod/* DRAGOVER_COMMAND */.kE, function (event) {
      return $onDragover(event);
    }, Lexical_prod/* COMMAND_PRIORITY_LOW */.KB), editor.registerCommand(Lexical_prod/* DROP_COMMAND */.zD, function (event) {
      return $onDrop(event, editor);
    }, Lexical_prod/* COMMAND_PRIORITY_HIGH */.Eo));
  }, [captionsEnabled, editor]);
  return null;
}
var TRANSPARENT_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

function $onDragStart(event) {
  var img = document.createElement("img");
  img.src = TRANSPARENT_IMAGE;
  var node = $getImageNodeInSelection();

  if (!node) {
    return false;
  }

  var dataTransfer = event.dataTransfer;

  if (!dataTransfer) {
    return false;
  }

  dataTransfer.setData("text/plain", "_");
  dataTransfer.setDragImage(img, 0, 0);
  dataTransfer.setData("application/x-lexical-drag", JSON.stringify({
    data: {
      altText: node.__altText,
      caption: node.__caption,
      height: node.__height,
      key: node.getKey(),
      maxWidth: node.__maxWidth,
      showCaption: node.__showCaption,
      src: node.__src,
      width: node.__width
    },
    type: "image"
  }));
  return true;
}

function $onDragover(event) {
  var node = $getImageNodeInSelection();

  if (!node) {
    return false;
  }

  if (!canDropImage(event)) {
    event.preventDefault();
  }

  return true;
}

function $onDrop(event, editor) {
  var node = $getImageNodeInSelection();

  if (!node) {
    return false;
  }

  var data = getDragImageData(event);

  if (!data) {
    return false;
  }

  event.preventDefault();

  if (canDropImage(event)) {
    var range = getDragSelection(event);
    node.remove();
    var rangeSelection = (0,Lexical_prod/* $createRangeSelection */.vN)();

    if (range !== null && range !== undefined) {
      rangeSelection.applyDOMRange(range);
    }

    (0,Lexical_prod/* $setSelection */.oq)(rangeSelection);
    editor.dispatchCommand(INSERT_IMAGE_COMMAND, data);
  }

  return true;
}

function $getImageNodeInSelection() {
  var selection = (0,Lexical_prod/* $getSelection */.dL)();

  if (!(0,Lexical_prod/* $isNodeSelection */.iO)(selection)) {
    return null;
  }

  var nodes = selection.getNodes();
  var node = nodes[0];
  return (0,ImageNode/* $isImageNode */.dP)(node) ? node : null;
}

function getDragImageData(event) {
  var _event$dataTransfer;

  var dragData = (_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer.getData("application/x-lexical-drag");

  if (!dragData) {
    return null;
  }

  var _JSON$parse = JSON.parse(dragData),
      type = _JSON$parse.type,
      data = _JSON$parse.data;

  if (type !== "image") {
    return null;
  }

  return data;
}

function canDropImage(event) {
  var target = event.target;
  return !!(target && target instanceof HTMLElement && !target.closest("code, figure.editor__image") && target.parentElement && target.parentElement.closest("div.editor-input"));
}

function getDragSelection(event) {
  var range;
  var target = event.target;
  var targetWindow = target == null ? null : target.nodeType === 9 ? target.defaultView : target.ownerDocument.defaultView;
  var domSelection = getDOMSelection(targetWindow);

  if (document.caretRangeFromPoint) {
    range = document.caretRangeFromPoint(event.clientX, event.clientY);
  } else if (event.rangeParent && domSelection !== null) {
    domSelection.collapse(event.rangeParent, event.rangeOffset || 0);
    range = domSelection.getRangeAt(0);
  } else {
    throw Error("Cannot get the selection when dragging");
  }

  return range;
}

/***/ }),

/***/ 94884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InstagramPlugin; },
/* harmony export */   "y": function() { return /* binding */ INSERT_INSTAGRAM_COMMAND; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46895);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _nodes_InstagramNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95706);






var INSERT_INSTAGRAM_COMMAND = (0,lexical__WEBPACK_IMPORTED_MODULE_2__/* .createCommand */ .fA)();
function InstagramPlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_nodes_InstagramNode__WEBPACK_IMPORTED_MODULE_1__/* .InstagramNode */ .Bs])) {
      throw new Error("InstagramPlugin: InstagramNode not registered on editor");
    }

    return editor.registerCommand(INSERT_INSTAGRAM_COMMAND, function (payload) {
      var instagramNode = (0,_nodes_InstagramNode__WEBPACK_IMPORTED_MODULE_1__/* .$createInstagramNode */ .rY)(payload);
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_5__/* .$insertNodeToNearestRoot */ .z8)(instagramNode);
      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_2__/* .COMMAND_PRIORITY_EDITOR */ .VN);
  }, [editor]);
  return null;
}

/***/ }),

/***/ 33184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XW": function() { return /* binding */ InsertLineLinkDialog; },
/* harmony export */   "ZP": function() { return /* binding */ LineLinkPlugin; }
/* harmony export */ });
/* unused harmony export INSERT_LINE_LINK_COMMAND */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46895);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61084);
/* harmony import */ var _nodes_LineLinkNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83943);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var _ui_TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6528);
/* harmony import */ var _ui_Dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57596);
/* harmony import */ var _ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71137);
/* harmony import */ var main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87687);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var INSERT_LINE_LINK_COMMAND = (0,lexical__WEBPACK_IMPORTED_MODULE_6__/* .createCommand */ .fA)("INSERT_LINE_LINK_COMMAND");
function InsertLineLinkDialog(_ref) {
  var activeEditor = _ref.activeEditor,
      onClose = _ref.onClose;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(["component", "button"]),
      t = _useTranslation.t;

  var defaultButtonText = t("cms.buttonTextPlaceholder");
  var defaultPromotionText = t("cms.promotionTextPlaceholder");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_5__/* .LINE_ADD_FRIEND_URL */ .Jg),
      url = _useState[0],
      setUrl = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultButtonText),
      buttonText = _useState2[0],
      setButtonText = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultPromotionText),
      promotionText = _useState3[0],
      setPromotionText = _useState3[1];

  var hasModifier = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var isDisabled = url === "" || buttonText === "";
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    hasModifier.current = false;

    var handler = function handler(e) {
      hasModifier.current = e.altKey;
    };

    document.addEventListener("keydown", handler);
    return function () {
      document.removeEventListener("keydown", handler);
    };
  }, [activeEditor]);

  var _onClick = function onClick(payload) {
    activeEditor.dispatchCommand(INSERT_LINE_LINK_COMMAND, payload);
    onClose();
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
    css: modalStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_ui_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      label: t("cms.lineUrl"),
      placeholder: "https://",
      onChange: setUrl,
      value: url,
      "data-test-id": "image-modal-url-input"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_ui_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      label: t("cms.buttonText"),
      placeholder: t("cms.buttonTextPlaceholder"),
      onChange: setButtonText,
      value: buttonText,
      "data-test-id": "image-modal-button-text-input"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_ui_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      label: t("cms.promotionText"),
      placeholder: t("cms.promotionTextPlaceholder"),
      onChange: setPromotionText,
      value: promotionText,
      "data-test-id": "image-modal-promotion-text-input"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_ui_Dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogActions */ .k, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        "data-test-id": "image-modal-confirm-btn",
        disabled: isDisabled,
        onClick: function onClick() {
          return _onClick({
            url: url,
            buttonText: buttonText,
            promotionText: promotionText
          });
        },
        children: t("button:common.add")
      })
    })]
  });
}
function LineLinkPlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_9__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_nodes_LineLinkNode__WEBPACK_IMPORTED_MODULE_1__/* .LineLinkNode */ .P$])) {
      throw new Error("LineLinkPlugin: LineLinkNode not registered on editor");
    }

    return editor.registerCommand(INSERT_LINE_LINK_COMMAND, function (payload) {
      var lineLinkNode = (0,_nodes_LineLinkNode__WEBPACK_IMPORTED_MODULE_1__/* .$createLineLinkNode */ .wr)(payload);
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_11__/* .$insertNodeToNearestRoot */ .z8)(lineLinkNode);
      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_6__/* .COMMAND_PRIORITY_EDITOR */ .VN);
  }, [editor]);
  return null;
}
var modalStyle =  true ? {
  name: "s57boe",
  styles: "width:40rem;max-width:85vw"
} : 0;

/***/ }),

/***/ 99620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListMaxIndentLevelPlugin; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _lexical_list__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88560);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46895);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */





function getElementNodesInSelection(selection) {
  var nodesInSelection = selection.getNodes();

  if (nodesInSelection.length === 0) {
    return new Set([selection.anchor.getNode().getParentOrThrow(), selection.focus.getNode().getParentOrThrow()]);
  }

  return new Set(nodesInSelection.map(function (n) {
    return (0,lexical__WEBPACK_IMPORTED_MODULE_1__/* .$isElementNode */ .F7)(n) ? n : n.getParentOrThrow();
  }));
}

function $shouldPreventIndent(maxDepth) {
  var selection = (0,lexical__WEBPACK_IMPORTED_MODULE_1__/* .$getSelection */ .dL)();

  if (!(0,lexical__WEBPACK_IMPORTED_MODULE_1__/* .$isRangeSelection */ .OP)(selection)) {
    return false;
  }

  var elementNodesInSelection = getElementNodesInSelection(selection);
  var totalDepth = 0;

  var _iterator = _createForOfIteratorHelper(elementNodesInSelection),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elementNode = _step.value;

      if ((0,_lexical_list__WEBPACK_IMPORTED_MODULE_2__/* .$isListNode */ .I3)(elementNode)) {
        totalDepth = Math.max((0,_lexical_list__WEBPACK_IMPORTED_MODULE_2__/* .$getListDepth */ .Rj)(elementNode) + 1, totalDepth);
      } else if ((0,_lexical_list__WEBPACK_IMPORTED_MODULE_2__/* .$isListItemNode */ .QG)(elementNode)) {
        var parent = elementNode.getParent();

        if (!(0,_lexical_list__WEBPACK_IMPORTED_MODULE_2__/* .$isListNode */ .I3)(parent)) {
          throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
        }

        totalDepth = Math.max((0,_lexical_list__WEBPACK_IMPORTED_MODULE_2__/* .$getListDepth */ .Rj)(parent) + 1, totalDepth);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return totalDepth > maxDepth;
}

function ListMaxIndentLevelPlugin(_ref) {
  var _ref$maxDepth = _ref.maxDepth,
      maxDepth = _ref$maxDepth === void 0 ? 7 : _ref$maxDepth;

  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return editor.registerCommand(lexical__WEBPACK_IMPORTED_MODULE_1__/* .INDENT_CONTENT_COMMAND */ .PU, function () {
      return $shouldPreventIndent(maxDepth);
    }, lexical__WEBPACK_IMPORTED_MODULE_1__/* .COMMAND_PRIORITY_CRITICAL */ .jw);
  }, [editor, maxDepth]);
  return null;
}

/***/ }),

/***/ 45893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchFormPlugin; },
/* harmony export */   "v": function() { return /* binding */ INSERT_SEARCH_FORM_COMMAND; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46895);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _nodes_SearchFormNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(421);






var INSERT_SEARCH_FORM_COMMAND = (0,lexical__WEBPACK_IMPORTED_MODULE_2__/* .createCommand */ .fA)("INSERT_SEARCH_FORM_COMMAND");
function SearchFormPlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0]; // 現在挿入時の設定ダイアログは無し


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_nodes_SearchFormNode__WEBPACK_IMPORTED_MODULE_1__/* .SearchFormNode */ .sc])) {
      throw new Error("SearchFormPlugin: SearchFormNode not registered on editor");
    }

    return editor.registerCommand(INSERT_SEARCH_FORM_COMMAND, function () {
      var lineLinkNode = (0,_nodes_SearchFormNode__WEBPACK_IMPORTED_MODULE_1__/* .$createSearchFormNode */ .jt)();
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_5__/* .$insertNodeToNearestRoot */ .z8)(lineLinkNode);
      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_2__/* .COMMAND_PRIORITY_EDITOR */ .VN);
  }, [editor]);
  return null;
}

/***/ }),

/***/ 12589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ INSERT_TWEET_COMMAND; },
/* harmony export */   "Z": function() { return /* binding */ TwitterPlugin; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46895);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _nodes_TweetNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44855);


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */





var INSERT_TWEET_COMMAND = (0,lexical__WEBPACK_IMPORTED_MODULE_2__/* .createCommand */ .fA)("INSERT_TWEET_COMMAND");
function TwitterPlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_nodes_TweetNode__WEBPACK_IMPORTED_MODULE_1__/* .TweetNode */ .je])) {
      throw new Error("TwitterPlugin: TweetNode not registered on editor");
    }

    return editor.registerCommand(INSERT_TWEET_COMMAND, function (payload) {
      var tweetNode = (0,_nodes_TweetNode__WEBPACK_IMPORTED_MODULE_1__/* .$createTweetNode */ .m2)(payload);
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_5__/* .$insertNodeToNearestRoot */ .z8)(tweetNode);
      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_2__/* .COMMAND_PRIORITY_EDITOR */ .VN);
  }, [editor]);
  return null;
}

/***/ }),

/***/ 6277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ INSERT_YOUTUBE_COMMAND; },
/* harmony export */   "Z": function() { return /* binding */ YouTubePlugin; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46895);
/* harmony import */ var _lexical_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18824);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _nodes_YouTubeNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21314);


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */





var INSERT_YOUTUBE_COMMAND = (0,lexical__WEBPACK_IMPORTED_MODULE_2__/* .createCommand */ .fA)("INSERT_YOUTUBE_COMMAND");
function YouTubePlugin() {
  var _useLexicalComposerCo = (0,_lexical_react_LexicalComposerContext__WEBPACK_IMPORTED_MODULE_3__/* .useLexicalComposerContext */ .g)(),
      _useLexicalComposerCo2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!editor.hasNodes([_nodes_YouTubeNode__WEBPACK_IMPORTED_MODULE_1__/* .YouTubeNode */ .gL])) {
      throw new Error("YouTubePlugin: YouTubeNode not registered on editor");
    }

    return editor.registerCommand(INSERT_YOUTUBE_COMMAND, function (payload) {
      var youTubeNode = (0,_nodes_YouTubeNode__WEBPACK_IMPORTED_MODULE_1__/* .$createYouTubeNode */ .kU)(payload);
      (0,_lexical_utils__WEBPACK_IMPORTED_MODULE_5__/* .$insertNodeToNearestRoot */ .z8)(youTubeNode);
      return true;
    }, lexical__WEBPACK_IMPORTED_MODULE_2__/* .COMMAND_PRIORITY_EDITOR */ .VN);
  }, [editor]);
  return null;
}

/***/ }),

/***/ 56693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CAN_USE_DOM; }
/* harmony export */ });
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var CAN_USE_DOM =  true && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";

/***/ }),

/***/ 36024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ invariant; }
/* harmony export */ });
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// invariant(condition, message) will refine types based on "condition", and
// if "condition" is false will throw an error. This function is special-cased
// in flow itself, so we can't name it anything else.
function invariant(cond, message) {
  if (cond) {
    return;
  }

  throw new Error("Internal Lexical error: invariant() is meant to be replaced at compile " + "time. There is no runtime version. Error: " + message);
}

/***/ }),

/***/ 35384:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var theme = {
  blockCursor: "editor__blockCursor",
  characterLimit: "editor__characterLimit",
  code: "editor__code",
  codeHighlight: {
    atrule: "editor__tokenAttr",
    attr: "editor__tokenAttr",
    "boolean": "editor__tokenProperty",
    builtin: "editor__tokenSelector",
    cdata: "editor__tokenComment",
    "char": "editor__tokenSelector",
    "class": "editor__tokenFunction",
    "class-name": "editor__tokenFunction",
    comment: "editor__tokenComment",
    constant: "editor__tokenProperty",
    deleted: "editor__tokenProperty",
    doctype: "editor__tokenComment",
    entity: "editor__tokenOperator",
    "function": "editor__tokenFunction",
    important: "editor__tokenVariable",
    inserted: "editor__tokenSelector",
    keyword: "editor__tokenAttr",
    namespace: "editor__tokenVariable",
    number: "editor__tokenProperty",
    operator: "editor__tokenOperator",
    prolog: "editor__tokenComment",
    property: "editor__tokenProperty",
    punctuation: "editor__tokenPunctuation",
    regex: "editor__tokenVariable",
    selector: "editor__tokenSelector",
    string: "editor__tokenSelector",
    symbol: "editor__tokenProperty",
    tag: "editor__tokenProperty",
    url: "editor__tokenOperator",
    variable: "editor__tokenVariable"
  },
  embedBlock: {
    base: "editor__embedBlock",
    focus: "editor__embedBlockFocus"
  },
  hashtag: "editor__hashtag",
  heading: {
    h1: "editor__h1",
    h2: "editor__h2",
    h3: "editor__h3",
    h4: "editor__h4",
    h5: "editor__h5",
    h6: "editor__h6"
  },
  image: "editor__image",
  indent: "editor__indent",
  inlineImage: "inline-editor-image",
  instagram: "editor__instagram",
  layoutContainer: "editor__layoutContaner",
  layoutItem: "editor__layoutItem",
  link: "editor__link",
  list: {
    listitem: "editor__listItem",
    listitemChecked: "editor__listItemChecked",
    listitemUnchecked: "editor__listItemUnchecked",
    nested: {
      listitem: "editor__nestedListItem"
    },
    olDepth: ["editor__ol1", "editor__ol2", "editor__ol3", "editor__ol4", "editor__ol5"],
    ul: "editor__ul"
  },
  ltr: "editor__ltr",
  mark: "editor__mark",
  markOverlap: "editor__markOverlap",
  paragraph: "editor__paragraph",
  quote: "editor__quote",
  rtl: "editor__rtl",
  tableBlock: "editor__tableBlock",
  tableBlockScrollable: "editor__tableBlockScrollable",
  tableBlockInner: "editor__tableBlockInner",
  table: "editor__table",
  tableScrollable: "editor__tableScrollable",
  tableAddColumns: "editor__tableAddColumns",
  tableAddRows: "editor__tableAddRows",
  tableCell: "editor__tableCell",
  tableCellActionButton: "editor__tableCellActionButton",
  tableCellActionButtonContainer: "editor__tableCellActionButtonContainer",
  tableCellEditing: "editor__tableCellEditing",
  tableCellHeader: "editor__tableCellHeader",
  tableCellPrimarySelected: "editor__tableCellPrimarySelected",
  tableCellResizer: "editor__tableCellResizer",
  tableCellSelected: "editor__tableCellSelected",
  tableCellSortedIndicator: "editor__tableCellSortedIndicator",
  tableResizeRuler: "editor__tableCellResizeRuler",
  tableSelected: "editor__tableSelected",
  tableSelection: "editor__tableSelection",
  text: {
    bold: "editor__textBold",
    code: "editor__textCode",
    italic: "editor__textItalic",
    strikethrough: "editor__textStrikethrough",
    subscript: "editor__textSubscript",
    superscript: "editor__textSuperscript",
    underline: "editor__textUnderline",
    underlineStrikethrough: "editor__textUnderlineStrikethrough"
  },
  tweet: "editor__tweet",
  youTube: "editor__youtube",
  lineLink: "editor__lineLink",
  searchForm: "editor__searchForm"
};
/* harmony default export */ __webpack_exports__["Z"] = (theme);

/***/ }),

/***/ 11110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ themeStyle; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/images/lexical/icons/plus.svg
var plus = __webpack_require__(30274);
var plus_default = /*#__PURE__*/__webpack_require__.n(plus);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/themes/ThemeStyleTabiChat.tsx



 // Editor/Postの両方で使用している

var themeStyleTabiChat = /*#__PURE__*/(0,emotion_react_browser_esm.css)(".editor__h2{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";&:after{content:\"\";width:calc(100% - 6rem);height:0.25rem;background-color:", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";border-left:6rem solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:1.625rem;line-height:1.5;}}.editor__h3{font-size:1.1875rem;line-height:1.5;&:before{width:0.25rem;min-width:0.25rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:1.4375rem;line-height:1.5;}}.editor__h4{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";}}" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/themes/ThemeStyle.tsx







var overwriteThemeStyle =  true ? undefined : 0; // Editor/Postの両方で使用している

var themeStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("h2,h3,h4{:target{padding-top:48px;margin-top:-48px;}}.editor__ltr{text-align:left;}.editor__rtl{text-align:right;}.editor__paragraph{position:relative;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:2;letter-spacing:0.05em;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";padding:calc(\n        ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2\n      ) ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}}.editor__quote{font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:2;letter-spacing:0.05em;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";margin:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom */.D.atom, ";border-left:0.375rem solid #eee;padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom3x */.D.atom3x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}}.editor__h1{font-size:24px;color:rgb(5, 5, 5);font-weight:400;margin:0;margin-bottom:12px;padding:0;}.editor__h2{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";margin-top:", spaceStyle/* space.atom4x */.D.atom4x, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";letter-spacing:0.05em;padding:calc(\n        ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.headline1 */.Nv.headline1, " - ", typographyStyle/* fontSize.headline */.JB.headline, ") / 2\n      ) ", spaceStyle/* space.atom */.D.atom, ";&:after{content:\"\";width:4.5rem;height:0.1875rem;display:block;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";margin:", spaceStyle/* space.atom2x */.D.atom2x, " 0 ", spaceStyle/* space.atom */.D.atom, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";line-height:", typographyStyle/* lineHeight.title */.Nv.title, ";padding:calc(\n          ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.title */.Nv.title, " - ", typographyStyle/* fontSize.title */.JB.title, ") / 2\n        ) ", spaceStyle/* space.atom */.D.atom, ";}}.editor__h3{display:flex;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";margin-top:", spaceStyle/* space.atom4x */.D.atom4x, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";letter-spacing:0.05em;padding:calc(\n        ", spaceStyle/* space.atom */.D.atom, " -\n          (", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, " - ", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ") / 2\n      ) ", spaceStyle/* space.atom */.D.atom, ";&:before{content:\"\";width:0.1875rem;min-width:0.1875rem;display:block;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";margin:0 ", spaceStyle/* space.atom2x */.D.atom2x, " 0 0;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";padding:calc(\n          ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.headline1 */.Nv.headline1, " - ", typographyStyle/* fontSize.headline */.JB.headline, ") / 2\n        ) ", spaceStyle/* space.atom */.D.atom, ";}}.editor__h4{font-size:", typographyStyle/* fontSize.subHeading */.JB.subHeading, ";line-height:", typographyStyle/* lineHeight.subHeadline1 */.Nv.subHeadline1, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";letter-spacing:0.05em;padding:calc(\n        ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.subHeadline2 */.Nv.subHeadline2, " - ", typographyStyle/* fontSize.subHeading */.JB.subHeading, ") /\n          2\n      ) ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, ";padding:calc(\n          ", spaceStyle/* space.atom */.D.atom, " -\n            (", typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1, " - ", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ") / 2\n        ) ", spaceStyle/* space.atom */.D.atom, ";}}.editor__indent{--lexical-indent-base-value:2.5rem;}.editor__textBold{font-weight:bold;}.editor__textItalic{font-style:italic;}.editor__textUnderline{text-decoration:underline;}.editor__textStrikethrough{text-decoration:line-through;}.editor__textUnderlineStrikethrough{text-decoration:underline line-through;}.editor__textSubscript{font-size:0.8em;vertical-align:sub!important;}.editor__textSuperscript{font-size:0.8em;vertical-align:super;}.editor__textCode{background-color:rgb(240, 242, 245);padding:1px 0.25rem;font-family:Menlo,Consolas,Monaco,monospace;font-size:94%;}.editor__hashtag{background-color:rgba(88, 144, 255, 0.15);border-bottom:1px solid rgba(88, 144, 255, 0.3);}.editor__link{color:", colorStyle/* accentColor.secondaryColor */.z.secondaryColor, ";text-decoration:underline;}.editor__link:hover{text-decoration:underline;}.editor__code{background-color:rgb(240, 242, 245);font-family:Menlo,Consolas,Monaco,monospace;display:block;padding:8px 8px 8px 52px;line-height:1.53;font-size:13px;margin:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom3x */.D.atom3x, ";tab-size:2;overflow-x:auto;position:relative;}.editor__code:before{content:attr(data-gutter);position:absolute;background-color:#eee;left:0;top:0;border-right:1px solid #ccc;padding:8px;color:#777;white-space:pre-wrap;text-align:right;min-width:25px;}.editor__tableBlock{position:relative;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");margin:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom4x */.D.atom4x, ";box-sizing:border-box;table{margin:0;width:100%;}}.editor__tableBlockScrollable{.editor__tableBlockInner{overflow-x:auto;}", (0,responsiveStyle/* lessThanBreakpoint */.eO)("tablet"), "{&:before,&:after{content:\"\";position:absolute;top:0;width:2rem;height:100%;opacity:0;pointer-events:none;transition:opacity 0.2s;}&:before{left:0;background:linear-gradient(\n          90deg,\n          rgba(0, 0, 0, 0.08),\n          rgba(0, 0, 0, 0)\n        );}&:after{right:0;background:linear-gradient(\n          270deg,\n          rgba(0, 0, 0, 0.08),\n          rgba(0, 0, 0, 0)\n        );}&.scroll--start{&:before{opacity:1;}}&.scroll--end{&:after{opacity:1;}}}}.editor__table{border-collapse:collapse;border-spacing:0;max-width:100%;overflow-y:scroll;table-layout:fixed;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");margin:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom4x */.D.atom4x, ";}.editor__tableScrollable{", (0,responsiveStyle/* lessThanBreakpoint */.eO)("tablet"), "{width:max-content!important;max-width:initial;margin:0;th,td{width:calc(\n          (100vw - var(--scrollbar-width) - (", spaceStyle/* space.atom2x */.D.atom2x, " * 8)) / 2.5\n        )!important;}}", (0,responsiveStyle/* lessThanBreakpoint */.eO)("phone"), "{th,td{width:calc(\n          (100vw - var(--scrollbar-width) - (", spaceStyle/* space.atom2x */.D.atom2x, " * 2)) / 2.5\n        )!important;}}}.editor__tableSelection *::selection{background-color:transparent;}.editor__tableSelected{outline:2px solid rgb(60, 132, 244);}.editor__tableCell{border:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, "!important;padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";vertical-align:top;text-align:start;box-sizing:border-box;width:auto!important;line-height:2;word-break:break-word;.editor__paragraph{margin-bottom:0;padding:0;}}.editor__tableCellSortedIndicator{display:block;opacity:0.5;position:absolute;bottom:0;left:0;width:100%;height:4px;background-color:#999;}.editor__tableCellResizer{position:absolute;right:-4px;height:100%;width:8px;cursor:ew-resize;z-index:10;top:0;}.editor__tableCellHeader{background-color:#f2f3f5;text-align:start;}.editor__tableCellSelected{background-color:#c9dbf0;}.editor__tableCellPrimarySelected{border:2px solid rgb(60, 132, 244);display:block;height:calc(100% - 2px);position:absolute;width:calc(100% - 2px);left:-1px;top:-1px;z-index:2;}.editor__tableCellEditing{box-shadow:0 0 5px rgba(0, 0, 0, 0.4);border-radius:3px;}.editor__tableAddColumns{position:absolute;top:0;width:20px;background-color:#eee;height:100%;right:0;animation:table-controls 0.2s ease;border:0;cursor:pointer;}.editor__tableAddColumns:after{background-image:url(", (plus_default()), ");background-size:contain;background-position:center;background-repeat:no-repeat;display:block;content:\" \";position:absolute;top:0;left:0;width:100%;height:100%;opacity:0.4;}.editor__tableAddColumns:hover{background-color:#c9dbf0;}.editor__tableAddRows{position:absolute;bottom:-25px;width:calc(100% - 25px);background-color:#eee;height:20px;left:0;animation:table-controls 0.2s ease;border:0;cursor:pointer;}.editor__tableAddRows:after{background-image:url(", (plus_default()), ");background-size:contain;background-position:center;background-repeat:no-repeat;display:block;content:\" \";position:absolute;top:0;left:0;width:100%;height:100%;opacity:0.4;}.editor__tableAddRows:hover{background-color:#c9dbf0;}@keyframes table-controls{0%{opacity:0;}100%{opacity:1;}}.editor__tableCellResizeRuler{display:block;position:absolute;width:1px;background-color:rgb(60, 132, 244);height:100%;top:0;}.editor__tableCellActionButtonContainer{display:block;right:5px;top:6px;position:absolute;z-index:4;width:20px;height:20px;}.editor__tableCellActionButton{background-color:#eee;display:block;border:0;border-radius:20px;width:20px;height:20px;color:#222;cursor:pointer;}.editor__tableCellActionButton:hover{background-color:#ddd;}.editor__characterLimit{display:inline;background-color:#ffbbbb!important;}.editor__ol1{margin:0 0 ", spaceStyle/* space.atom3x */.D.atom3x, ";padding:0 0.5rem 0 1.5rem;}.editor__ol2{padding:0;margin:0;margin-left:16px;list-style-type:upper-alpha;list-style-position:inside;}.editor__ol3{padding:0;margin:0;margin-left:16px;list-style-type:lower-alpha;list-style-position:inside;}.editor__ol4{padding:0;margin:0;margin-left:16px;list-style-type:upper-roman;list-style-position:inside;}.editor__ol5{padding:0;margin:0;margin-left:16px;list-style-type:lower-roman;list-style-position:inside;}.editor__ul{margin:0 0 ", spaceStyle/* space.atom3x */.D.atom3x, ";padding:0 0.5rem 0 1.5rem;}.editor__listItem{font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";letter-spacing:0.05em;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";margin-bottom:", spaceStyle/* space.atom */.D.atom, ";margin-left:", spaceStyle/* space.atom */.D.atom, ";padding:calc(", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body2 */.Nv.body2, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}}.editor__listItemChecked,.editor__listItemUnchecked{position:relative;margin-left:8px;margin-right:8px;padding-left:24px;padding-right:24px;list-style-type:none;outline:none;}.editor__listItemChecked{text-decoration:line-through;}.editor__listItemUnchecked:before,.editor__listItemChecked:before{content:\"\";width:16px;height:16px;top:2px;left:0;cursor:pointer;display:block;background-size:cover;position:absolute;}.editor__listItemUnchecked[dir=\"rtl\"]:before,.editor__listItemChecked[dir=\"rtl\"]:before{left:auto;right:0;}.editor__listItemUnchecked:focus:before,.editor__listItemChecked:focus:before{box-shadow:0 0 0 2px #a6cdfe;border-radius:2px;}.editor__listItemUnchecked:before{border:1px solid #999;border-radius:2px;}.editor__listItemChecked:before{border:1px solid rgb(61, 135, 245);border-radius:2px;background-color:#3d87f5;background-repeat:no-repeat;}.editor__listItemChecked:after{content:\"\";cursor:pointer;border-color:#fff;border-style:solid;position:absolute;display:block;top:6px;width:3px;left:7px;height:6px;transform:rotate(45deg);border-width:0 2px 2px 0;}.editor__nestedListItem{list-style-type:none;}.editor__nestedListItem:before,.editor__nestedListItem:after{display:none;}.editor__tokenComment{color:slategray;}.editor__tokenPunctuation{color:#999;}.editor__tokenProperty{color:#905;}.editor__tokenSelector{color:#690;}.editor__tokenOperator{color:#9a6e3a;}.editor__tokenAttr{color:#07a;}.editor__tokenVariable{color:#e90;}.editor__tokenFunction{color:#dd4a68;}.editor__mark{background:rgba(255, 212, 0, 0.14);border-bottom:2px solid rgba(255, 212, 0, 0.3);padding-bottom:2px;}.editor__markOverlap{background:rgba(255, 212, 0, 0.3);border-bottom:2px solid rgba(255, 212, 0, 0.7);}.editor__mark.selected{background:rgba(255, 212, 0, 0.5);border-bottom:2px solid rgba(255, 212, 0, 1);}.editor__markOverlap.selected{background:rgba(255, 212, 0, 0.7);border-bottom:2px solid rgba(255, 212, 0, 0.7);}.editor__embedBlock{user-select:none;}.editor__embedBlockFocus{outline:2px solid rgb(60, 132, 244);}.editor__layoutContaner{display:grid;gap:", spaceStyle/* space.atom */.D.atom, ";margin:", spaceStyle/* space.atom */.D.atom, " 0;}.editor__layoutItem{border:1px dashed #ddd;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}.editor__image{max-width:100%;margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";img{box-sizing:border-box;max-width:100%;}figcaption{padding-top:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";a{color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";}p{font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";margin:0;padding:0;letter-spacing:0;}}}.editor__instagram{padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";max-width:100%;box-sizing:border-box;iframe{max-width:100%;margin:0!important;}}.editor__tweet{padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";max-width:100%;box-sizing:border-box;.twitter-tweet{margin:0!important;max-width:542px!important;}iframe{max-width:100%;}}.editor__youtube{width:100%;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";box-sizing:border-box;margin-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";&>div{position:relative;padding-bottom:56.25%;overflow:hidden;}iframe{position:absolute;top:0;left:0;width:100%;height:100%;}}.editor__lineLink{width:fit-content;margin:0 auto ", spaceStyle/* space.atom3x */.D.atom3x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";.promotion{text-align:center;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";margin-bottom:", spaceStyle/* space.atom */.D.atom, ";max-width:30rem;padding:0 ", spaceStyle/* space.atom2x */.D.atom2x, ";.promotion-text{position:relative;display:inline-block;padding:0 ", spaceStyle/* space.atom */.D.atom, ";letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";&:before,&:after{content:\"\";position:absolute;background:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";width:2px;height:24px;}&:before{left:-10px;bottom:-2px;transform-origin:left center;transform:rotate(-30deg);}&:after{right:-10px;bottom:-2px;transform-origin:right center;transform:rotate(30deg);}}}.button{display:flex;min-width:17.5rem;max-width:30rem;min-height:3.125rem;text-decoration:none;margin:0 auto;position:relative;.inner{display:flex;width:100%;background:", colorStyle/* accentColor.lineColor */.z.lineColor, ";box-shadow:0 4px 0 ", (0,colorStyle/* shadeColor */.HO)(colorStyle/* accentColor.lineColor */.z.lineColor, -20), ";border-radius:0.5rem;color:#fff;transition:background-color 0.3s ease,box-shadow 0.3s ease;&:hover{background-color:", (0,colorStyle/* shadeColor */.HO)(colorStyle/* accentColor.lineColor */.z.lineColor, 5), ";box-shadow:0 4px 0 ", (0,colorStyle/* shadeColor */.HO)(colorStyle/* accentColor.lineColor */.z.lineColor, -10), ";}}}.symbol{position:relative;display:flex;align-items:center;justify-content:center;width:44px;box-sizing:border-box;border-right:1px solid rgba(0, 0, 0, 0.1);img{width:26px;}}.text{font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";line-height:1.4;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";display:flex;align-items:center;flex:1;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";}}.editor__searchForm{max-width:500px;margin:0 auto ", spaceStyle/* space.atom3x */.D.atom3x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";.mock{}.inner{border-radius:8px;border:1px solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";box-shadow:0 0.125rem 1rem ", colorStyle/* shadowColor.soft */.nm.soft, ";overflow:hidden;}.category-tab{border-bottom:1px solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";display:flex;}.tab{position:relative;cursor:pointer;display:flex;flex-direction:column;justify-content:center;padding:0 0.1rem 1px;font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";text-align:center;height:44px;color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";box-sizing:border-box;background-color:#fff;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 1rem 1px;flex-direction:row;align-items:center;height:38px;line-height:41px;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";}}.form-block{padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";height:2.5rem;}}hr{margin:", spaceStyle/* space.atom2x */.D.atom2x, ";border-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";}", overwriteThemeStyle, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 71137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/utils/joinClasses.ts
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function joinClasses() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join(" ");
}
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/editor/ui/Button.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// import './Button.css';




function Button(_ref) {
  var dataTestId = _ref["data-test-id"],
      children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      small = _ref.small,
      title = _ref.title;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", _objectSpread(_objectSpread({
    css: buttonStyle,
    disabled: disabled,
    className: joinClasses("Button__root", disabled && "Button__disabled", small && "Button__small", className),
    onClick: onClick,
    title: title,
    "aria-label": title
  }, dataTestId && {
    "data-test-id": dataTestId
  }), {}, {
    children: children
  }));
}
var buttonStyle =  true ? {
  name: "k7m4c4",
  styles: "&.Button__root{padding-top:10px;padding-bottom:10px;padding-left:15px;padding-right:15px;border:0px;background-color:#eee;border-radius:5px;cursor:pointer;font-size:14px;}&.Button__root:hover{background-color:#ddd;}&.Button__small{padding-top:5px;padding-bottom:5px;padding-left:10px;padding-right:10px;font-size:13px;}&.Button__disabled{cursor:not-allowed;}&.Button__disabled:hover{background-color:#eee;}"
} : 0;

/***/ }),

/***/ 57596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DialogButtonsList; },
/* harmony export */   "k": function() { return /* binding */ DialogActions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// import './Dialog.css';



function DialogButtonsList(_ref) {
  var children = _ref.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
    className: "DialogButtonsList",
    css: dialogButtonListStyle,
    children: children
  });
}
function DialogActions(_ref2) {
  var dataTestId = _ref2["data-test-id"],
      children = _ref2.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
    className: "DialogActions",
    css: dialogActionsStyle,
    "data-test-id": dataTestId,
    children: children
  });
}
var dialogActionsStyle =  true ? {
  name: "4y34dc",
  styles: "display:flex;flex-direction:row;justify-content:right;margin-top:20px;.DialogButtonsList{display:flex;flex-direction:column;justify-content:right;margin-top:20px;}.DialogButtonsList button{margin-bottom:20px;}"
} : 0;
var dialogButtonListStyle =  true ? {
  name: "b32w83",
  styles: "display:flex;flex-direction:column;justify-content:right;margin-top:20px;button{margin-bottom:20px;}"
} : 0;

/***/ }),

/***/ 6528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */




function TextInput(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _onChange = _ref.onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      dataTestId = _ref["data-test-id"],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    css: inputWrapperStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("label", {
      css: inputLabelStyle,
      children: label
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("input", {
      type: type,
      css: inputInputStyle,
      placeholder: placeholder,
      value: value,
      onChange: function onChange(e) {
        _onChange(e.target.value);
      },
      "data-test-id": dataTestId
    })]
  });
}
var inputWrapperStyle =  true ? {
  name: "1ikuzr3",
  styles: "display:flex;flex-direction:row;align-items:center;margin-bottom:10px"
} : 0;
var inputLabelStyle =  true ? {
  name: "1a63edk",
  styles: "display:flex;flex:1;color:#666"
} : 0;
var inputInputStyle =  true ? {
  name: "4qx7ll",
  styles: "display:flex;flex:2;border:1px solid #999;padding-top:7px;padding-bottom:7px;padding-left:10px;padding-right:10px;font-size:16px;border-radius:5px;min-width:0"
} : 0;

/***/ }),

/***/ 65562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HotelDatePickerBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32912);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27114);
/* harmony import */ var main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82011);
/* harmony import */ var main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19484);
/* harmony import */ var main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31264);
/* harmony import */ var main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10780);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16201);
/* harmony import */ var main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71797);
/* harmony import */ var main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16341);
/* harmony import */ var _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96749);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14416);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12327);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }























var HotelDatePickerBlockComponent = function HotelDatePickerBlockComponent(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useWatch */ .qo)({
    control: control,
    name: ["checkin_date", "checkout_date"]
  }),
      _useWatch2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_useWatch, 2),
      checkinDateValue = _useWatch2[0],
      checkoutDateValue = _useWatch2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputCheckInRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var inputCheckOutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // public shouldComponentUpdate(nextProps: any, nextState: any): boolean {
  //   return !isEqual(props, nextProps) || !isEqual(state, nextState);
  // }

  var onClickCheckinDate = function onClickCheckinDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate);
  };

  var onClickCheckoutDate = function onClickCheckoutDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
  };

  var sendDateEvent = function sendDateEvent(checkinDateString, checkoutDateString) {
    if (checkinDateString && checkoutDateString) {
      (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__/* .GoogleTagManagerEventTypes.date */ .T.date, {
        start_date: checkinDateString,
        end_date: checkoutDateString
      });
    }
  };

  var onComplete = function onComplete(startDate, endDate) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  }; // 再レンダリングの負荷が高い場合はメモ化検討する


  var fromDate = checkinDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkinDateValue) : null;
  var toDate = checkoutDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkoutDateValue) : null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
      css: inputBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__/* .CheckinInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate,
        onClick: onClickCheckinDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckInRef
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__/* .CheckoutInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate,
        onClick: onClickCheckoutDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckOutRef
      })]
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__/* .FullScreenModalDialog */ .H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__/* .ScrollableDatePicker */ .d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.checkinDate"),
        endDateLabel: t("label:common.checkoutDate"),
        dateType: pickerDateType
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__/* .HorizontalDatePicker */ .R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.checkinDate"),
      endDateLabel: t("label:common.checkoutDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputCheckInRef.current,
      toInputRef: inputCheckOutRef.current
    })]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()(prevProps, nextProps);
};

var HotelDatePickerBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(HotelDatePickerBlockComponent, areEqual);
var blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var inputBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_20__.css)("display:flex;padding:", _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 83981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ HotelDestinationBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1399);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62394);
/* harmony import */ var main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86058);
/* harmony import */ var _form_InputHidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81047);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14416);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88433);
/* harmony import */ var _suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50193);
/* harmony import */ var _molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19484);
/* harmony import */ var _suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83827);
/* harmony import */ var _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36716);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36581);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12327);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);






















var HotelDestinationBlock = function HotelDestinationBlock(props) {
  var fetchHotelDestinationSuggestions = props.fetchHotelDestinationSuggestions,
      defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_15__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var appDispatch = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var destinations = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationSuggestionsSelector */ .s0);
  var isLoading = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .loadingSelector */ .E2);
  var currentInputData = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationInputDataSelector */ .TW);
  var currentInputText = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.text;
  var currentInputLongName = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.longName; // TODO: 旧reducerをそのまま使用

  var accountDefaultDestinations = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.accountParamsReducer.destinations;
  });
  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_16__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      trigger = _useFormContext.trigger;

  var fieldName = "destination";
  var idFieldName = "destination_id";
  var typeFieldName = "destination_type";
  var longitudeFieldName = "longitude";
  var latitudeFieldName = "latitude";
  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_16__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  }) || "";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var valueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  valueRef.current = value;
  var currentInputLongNameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(currentInputLongName);
  currentInputLongNameRef.current = currentInputLongName;
  var currentValue = (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? value : value;
  var suggestions = currentValue ? destinations : defaultDestinations || accountDefaultDestinations;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    clearTimeout(inputTimeoutRef.current);
    var inputText = currentValue;
    setValue(fieldName, suggestion.longName);
    setValue(idFieldName, suggestion.id);
    setValue(typeFieldName, suggestion.destinationType);
    setValue(longitudeFieldName, suggestion.centerCoordinates[0]);
    setValue(latitudeFieldName, suggestion.centerCoordinates[1]);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: inputText,
      longName: suggestion.longName
    }));
    void trigger([fieldName, idFieldName]);
    (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__/* .GoogleTagManagerEventTypes.origin */ .T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(idFieldName, null);
    setValue(fieldName, "");
    setValue(typeFieldName, "");
    setValue(longitudeFieldName, null);
    setValue(latitudeFieldName, null);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: "",
      longName: ""
    }));
  }; // reactではinputのvalueが外から変更されてもonChangeが呼ばれないため
  // 変更後のvalueをreact-autosuggestが使用できない
  // そのためreact-autosuggestのfocus時のrequestを
  // disableOnFocusRequestで抑止し、独自でリクエストする


  var onFocus = function onFocus() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, currentInputText);

    if (currentInputText) {
      fetchHotelDestinationSuggestions({
        text: currentInputText
      });
    }
  };

  var onBlur = function onBlur() {
    // onSelectedより先に呼ばれるため遅延させる
    inputTimeoutRef.current = setTimeout(function () {
      if ( // valueRef.current &&
      currentInputLongNameRef.current && valueRef.current !== currentInputLongNameRef.current) {
        setValue(fieldName, currentInputLongNameRef.current);
        void trigger(fieldName);
      }
    }, 400);
  };

  var error = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_16__/* .get */ .U2)(errors, fieldName) || (0,react_hook_form__WEBPACK_IMPORTED_MODULE_16__/* .get */ .U2)(errors, idFieldName);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: idFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: typeFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: "center_coordinates[]"
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__/* .SuggestionFieldButton */ .M, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__/* .FormNamespaces.hotel */ .Z.hotel,
        name: fieldName,
        label: {
          namespace: "hotel",
          label: "都市・地域名、ホテル名から検索",
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        error: error
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__/* .FullScreenModalDialog */ .H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: headerTitleStyle,
          children: t("hotel.destination")
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__/* .SuggestionPicker */ .W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchHotelDestinationSuggestions,
          onSelected: onSelected,
          onFocus: onFocus,
          onBlur: onBlur,
          onClear: onClearInput
        })]
      })]
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__/* .InputAutosuggestBlock */ .A, {
      namespace: "hotel",
      label: {
        namespace: "hotel",
        label: "都市・地域名、ホテル名から検索",
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: "目的地またはホテル名を入力"
      },
      error: error,
      onSelected: onSelected,
      onFocus: onFocus,
      onBlur: onBlur,
      fetchDestinationSuggest: fetchHotelDestinationSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:bold;letter-spacing:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .letterSpacing.text */ .rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 90266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ postSearchDynamicPackageCache; },
/* harmony export */   "Ui": function() { return /* binding */ postResearchDynamicPackageCache; },
/* harmony export */   "Z0": function() { return /* binding */ convertSearchDynamicPackageFormValuesToParams; }
/* harmony export */ });
/* unused harmony export searchDynamicPackageSlice */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95094);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);
/* harmony import */ var _manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11166);
/* harmony import */ var _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45021);
/* harmony import */ var _utils_googleAnalyticsUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48207);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var key = "searchDynamicPackage";
var initialState = {
  loading: false,
  errors: null
};
/** Async **/

var postSearchDynamicPackageCache = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("".concat(key, "/postSearchDynamicPackageCache"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, url, utmValues, requestParams, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/search_dynamic_package/cache");
            utmValues = (0,_utils_googleAnalyticsUtil__WEBPACK_IMPORTED_MODULE_7__/* .getUtmValues */ .A)();
            requestParams = _objectSpread(_objectSpread({}, utmValues), params);
            _context.next = 8;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
              conditions: requestParams
            }));

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              data: result.data
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var postResearchDynamicPackageCache = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("".concat(key, "/postResearchDynamicPackageCache"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, cacheId, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            cacheId = args.cacheId;
            url = "/api/research_dynamic_package/cache.json";
            _context2.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
              cacheId: cacheId
            }));

          case 6:
            result = _context2.sent;
            console.log(result);
            return _context2.abrupt("return", {
              data: result.data
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context2.t0.response.data)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
/** slice **/

var searchDynamicPackageSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
var convertSearchDynamicPackageFormValuesToParams = function convertSearchDynamicPackageFormValuesToParams(data) {
  var _params$guests;

  var params = (0,_manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_10__/* .clone */ .d9)(data);

  if (params.flight_type === _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__/* .FlightTypes.multiCity */ .z.multiCity) {
    delete params.departure_date;
    delete params.return_date;
  } else if (params.flight_type === _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__/* .FlightTypes.oneWay */ .z.oneWay) {
    delete params.return_date;
    delete params.itineraries;
  } else {
    delete params.itineraries;
  }

  if (((_params$guests = params.guests) === null || _params$guests === void 0 ? void 0 : _params$guests.length) > 0) {
    params.guests.map(function (guest, index) {
      if (Number(guest.number_of_children) > 0) {
        params.guests[index].ages_of_children = guest.ages_of_children.map(function (age) {
          return age.age;
        });
      } else {
        delete params.guests[index].ages_of_children;
      }
    });
  }

  return params;
};

/***/ }),

/***/ 35047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ SearchDynamicPackage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/CabinClassBlock.tsx
var CabinClassBlock = __webpack_require__(84077);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightOriginDestinationDate.tsx + 12 modules
var FlightOriginDestinationDate = __webpack_require__(46385);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx + 3 modules
var GuestsBlock = __webpack_require__(88452);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 2 modules
var store = __webpack_require__(62394);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/features/dynamicPackage/searchDynamicPackageSlice.ts
var searchDynamicPackageSlice = __webpack_require__(90266);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/features/post/postSlice.ts
var postSlice = __webpack_require__(78121);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchFieldButtonSymbol.tsx
var SearchFieldButtonSymbol = __webpack_require__(60629);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchDynamicPackageFieldButton.tsx









var SearchDynamicPackageFieldButton = function SearchDynamicPackageFieldButton(props) {
  var onClick = props.onClick;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var destinationFieldName = "destination";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: destinationFieldName
  }) || "";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: buttonStyle,
      onClick: onClick,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: destinationStyle,
        children: value
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFieldButtonSymbol/* SearchFieldButtonSymbol */.H, {})]
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:space-between;align-items:center;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var destinationStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding-right:", spaceStyle/* space.atom */.D.atom, ";overflow-wrap:anywhere;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts + 1 modules
var ModalDialogWithClose = __webpack_require__(99717);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchDynamicPackage.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






































var defaultValues = {
  departure_date: null,
  // undefinedではダメ
  return_date: null,
  // undefinedではダメ
  traveler: {
    number_of_adult: 2,
    number_of_children: 0
  },
  access_type: "direct_web",
  flight_type: (0,humps.decamelize)("roundTrip"),
  cabin_class: "Y",
  itineraries: [{
    departure_date: null
  }, {
    departure_date: null
  }],
  number_of_rooms: 1,
  guests: [{
    number_of_adult: 2,
    number_of_children: 0,
    ages_of_children: []
  }]
};
es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = es/* object */.Ry().shape({
  origin: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  origin_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  destination: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  destination_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  departure_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  return_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  itineraries: es/* array */.IX().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: function then(schema) {
      return schema.of(es/* object */.Ry().shape({
        origin: es/* string */.Z_().required(),
        origin_id: es/* number */.Rx().required(),
        destination: es/* string */.Z_().required(),
        destination_id: es/* number */.Rx().required(),
        departure_date: es/* string */.Z_().nullable().required()
      }));
    }
  }),
  guests: es/* array */.IX().of(es/* object */.Ry().shape({
    number_of_children: es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: es/* array */.IX().of(es/* object */.Ry().shape({
        age: es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var SearchDynamicPackage = function SearchDynamicPackage(props) {
  var _post$origins, _post$flightDestinati;

  var _props$isCompact = props.isCompact,
      isCompact = _props$isCompact === void 0 ? false : _props$isCompact;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var post = (0,store/* useAppSelector */.CG)(postSlice/* postSelector */.pm); // TODO: 旧reducer

  var breakpoint = (0,react_redux_es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = (0,react.useState)(false),
      displayedPicker = _useState2[0],
      setDisplayedPicker = _useState2[1];

  var defaultOrigin = {};

  if (((_post$origins = post.origins) === null || _post$origins === void 0 ? void 0 : _post$origins.length) > 0) {
    var origin = post.origins[0];
    defaultOrigin = {
      origin: origin.longName,
      origin_id: origin.id,
      origin_type: origin.destinationType
    };
  }

  var defaultDestination = {};

  if (((_post$flightDestinati = post.flightDestinations) === null || _post$flightDestinati === void 0 ? void 0 : _post$flightDestinati.length) > 0) {
    var destination = post.flightDestinations[0];
    defaultDestination = {
      destination: destination.name,
      destination_id: destination.id,
      destination_type: destination.destinationType
    };
  }

  var defaultOriginDestination = _objectSpread(_objectSpread({}, defaultOrigin), defaultDestination);

  (0,react.useEffect)(function () {
    if ((0,responsiveStyle/* isDesktop */.nI)(breakpoint)) {
      (0,ScrollUtil/* stopBodyScrolling */.wV)(displayedPicker);
    }
  }, [displayedPicker]);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), defaultOriginDestination)
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values, _) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              params = (0,searchDynamicPackageSlice/* convertSearchDynamicPackageFormValuesToParams */.Z0)(values);
              return _context.abrupt("return", appDispatch((0,searchDynamicPackageSlice/* postSearchDynamicPackageCache */.Gq)({
                params: _objectSpread(_objectSpread({}, params), PostConstants/* PostSearchGAParams */.fy)
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                (0,googleTagManagerUtil/* dpAvailabilitiesEvent */.Yy)(result.data.dynamicPackageId, params);
                var gaParams = (0,lib.stringify)(PostConstants/* PostSearchGAParams */.fy, {
                  arrayFormat: "indices"
                });
                window.location.href = "".concat(Constants/* TABI_DOMAIN */.xQ, "/flights?").concat((0,lib.stringify)((0,humps.decamelizeKeys)(result.data.conditions), {
                  arrayFormat: "indices"
                }), "\n&cache_id=").concat(result.data.cacheId, "\n&dynamic_package_id=").concat(result.data.dynamicPackageId, "&search_group_id=").concat(result.data.searchGroupId, "&search_type=dp&").concat(gaParams);
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);

                if (Array.isArray(errorResponse.errors)) {
                  var errorMessages = errorResponse.errorMessages;
                  (0,FormUtil/* convertServerErrorToForm */.f)({
                    messages: errorMessages
                  }, setError);
                } else {
                  // エラー形式を合わせるために変換している
                  var _errors = Object.keys(errorResponse.errors).map(function (key) {
                    return (0,defineProperty/* default */.Z)({}, key, errorResponse.errors[key]);
                  });

                  (0,FormUtil/* convertServerErrorToForm */.f)({
                    fieldMessages: _errors
                  }, setError);
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchFlightDestinationSuggestionsAction = function fetchFlightDestinationSuggestionsAction(data, type) {
    appDispatch((0,flightSuggestionSlice/* debouncedFetchFlightDestinationSuggestions */.tk)({
      params: {
        text: data.text
      },
      type: type
    }));
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var formFieldsStyles = isCompact ? [formFieldsStyle, formScrollStyle] : formFieldsStyle;

  var renderForm = function renderForm() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [isCompact && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: headerTitleStyle,
        children: t("post.dynamicPackageSearch")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
        method: "GET",
        action: "/flights",
        onSubmit: handleFormSubmit,
        css: formStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: formInnerStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: formFieldsStyles,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginDestinationDate/* FlightOriginDestinationDate */.e, {
              destinationSuggestOptions: {},
              fetchFlightOriginDestinationSuggestions: fetchFlightDestinationSuggestionsAction,
              defaultOrigins: post.origins,
              defaultDestinations: post.flightDestinations,
              useDatePicker: true,
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary",
              disableStopBodyScrolling: true
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: flightClassBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinClassBlock/* CabinClassBlock */.B, {
                labelColorStyleKey: "default",
                borderColorStyleKey: "primary"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary"
            }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
                namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
                errors: errors,
                hideValidationErrors: true
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: submitBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: buttonBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
                type: "submit",
                disabled: isSubmitting,
                isLoading: isSubmitting,
                children: "\u691C \u7D22"
              })
            })
          })]
        })
      })]
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchDynamicPackage_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: isCompact ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchDynamicPackageFieldButton, {
          onClick: onPickerButtonClick
        }), (0,responsiveStyle/* isDesktop */.nI)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDialogWithClose/* ModalDialogWithClose */.T, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          styleKey: "noInnerContentPadding",
          innerStyles: {
            maxWidth: maxWidthStyle/* maxWidth.page1col */.k.page1col,
            height: "680px"
          },
          children: renderForm()
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          colorMode: "light",
          children: renderForm()
        })]
      }) : renderForm()
    }))
  });
};
var SearchDynamicPackage_blockStyle =  true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0;
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
var formStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var formInnerStyle =  true ? {
  name: "13ku56z",
  styles: "display:flex;flex-direction:column;height:100%"
} : 0;
var formFieldsStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var formScrollStyle =  true ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : 0;
var flightClassBlockStyle =  true ? {
  name: "11vmki4",
  styles: "width:50%;min-width:200px"
} : 0;
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;justify-content:flex-end;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 60629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SearchFieldButtonSymbol; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_components_icon_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65147);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var _styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88433);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);










var SearchFieldButtonSymbol = function SearchFieldButtonSymbol() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t;

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_icon_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
      styleKey: "search"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      children: t("post.bestPriceSearch")
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("width:auto;height:2.5rem;display:flex;align-items:center;justify-content:center;gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.caption */ .JB.caption, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.bold */ .Ue.bold, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .accentColor.primaryColor */ .z.primaryColor, ";border-radius:5px;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, ";white-space:nowrap;i{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";font-size:1rem;margin-left:-0.125rem;}", (0,_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 80700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchFlight; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightTravelerBlock.tsx
var FlightTravelerBlock = __webpack_require__(90652);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/CabinClassBlock.tsx
var CabinClassBlock = __webpack_require__(84077);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightOriginDestinationDate.tsx + 12 modules
var FlightOriginDestinationDate = __webpack_require__(46385);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/FlightTypeBlock.tsx
var FlightTypeBlock = __webpack_require__(28090);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/constants/SearchCategories.ts
var SearchCategories = __webpack_require__(80264);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 2 modules
var store = __webpack_require__(62394);
// EXTERNAL MODULE: ./main/javascripts/features/flight/searchFlightSlice.ts + 1 modules
var searchFlightSlice = __webpack_require__(71900);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts + 1 modules
var ModalDialogWithClose = __webpack_require__(99717);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchFieldButtonSymbol.tsx
var SearchFieldButtonSymbol = __webpack_require__(60629);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchFlightFieldButton.tsx











var SearchFlightFieldButton = function SearchFlightFieldButton(props) {
  var onClick = props.onClick;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var flightTypeFieldName = "flight_type";
  var destinationFieldName = "destination";
  var itineraryDestinationFieldName = "itineraries.0.destination";

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: [flightTypeFieldName, destinationFieldName, itineraryDestinationFieldName]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 3),
      flightTypeValue = _useWatch2[0],
      destinationValue = _useWatch2[1],
      itineraryDestinationValue = _useWatch2[2];

  var currentValue = flightTypeValue === FlightTypes/* FlightTypes.multiCity */.z.multiCity ? itineraryDestinationValue : destinationValue;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: buttonStyle,
      onClick: onClick,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: destinationStyle,
        children: currentValue || ""
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFieldButtonSymbol/* SearchFieldButtonSymbol */.H, {})]
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:space-between;align-items:center;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var destinationStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding-right:", spaceStyle/* space.atom */.D.atom, ";overflow-wrap:anywhere;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/features/post/postSlice.ts
var postSlice = __webpack_require__(78121);
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchFlight.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








































var defaultValues = {
  departure_date: null,
  // undefinedではダメ
  return_date: null,
  // undefinedではダメ
  traveler: {
    number_of_adult: 2,
    number_of_children: 0
  },
  access_type: "direct_web",
  flight_type: (0,humps.decamelize)("roundTrip"),
  cabin_class: "Y",
  itineraries: [{
    departure_date: null
  }, {
    departure_date: null
  }]
};
es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = es/* object */.Ry().shape({
  origin: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  origin_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  destination: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  destination_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  departure_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  return_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  itineraries: es/* array */.IX().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: function then(schema) {
      return schema.of(es/* object */.Ry().shape({
        origin: es/* string */.Z_().required(),
        origin_id: es/* number */.Rx().required(),
        destination: es/* string */.Z_().required(),
        destination_id: es/* number */.Rx().required(),
        departure_date: es/* string */.Z_().nullable().required()
      }));
    }
  }),
  traveler: es/* object */.Ry().shape({
    number_of_children: es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: es/* array */.IX().of(es/* object */.Ry().shape({
        age: es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required().test("infantsNumber", "infantsNumber", function (value, context) {
          var _parent2$value, _parent2$value2;

          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          var _context$from = (0,slicedToArray/* default */.Z)(context.from, 2),
              _ = _context$from[0],
              parent2 = _context$from[1];

          var infantsNumber = ((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value = parent2.value) === null || _parent2$value === void 0 ? void 0 : _parent2$value.ages_of_children) || []).filter(function (age) {
            // 空文字を無視したいためparseIntを使用
            return parseInt(age.age) <= 1;
          }).length;
          var adultsNumber = Number((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value2 = parent2.value) === null || _parent2$value2 === void 0 ? void 0 : _parent2$value2.number_of_adult) || 1);
          return infantsNumber <= adultsNumber;
        })
      }))
    })
  })
});
var SearchFlight = function SearchFlight(props) {
  var _post$origins, _post$flightDestinati;

  var _props$isCompact = props.isCompact,
      isCompact = _props$isCompact === void 0 ? false : _props$isCompact;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var post = (0,store/* useAppSelector */.CG)(postSlice/* postSelector */.pm); // TODO: 旧reducer

  var breakpoint = (0,react_redux_es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = (0,react.useState)(false),
      displayedPicker = _useState2[0],
      setDisplayedPicker = _useState2[1];

  var defaultOrigin = {};

  if (((_post$origins = post.origins) === null || _post$origins === void 0 ? void 0 : _post$origins.length) > 0) {
    var origin = post.origins[0];
    defaultOrigin = {
      origin: origin.longName,
      origin_id: origin.id,
      origin_type: origin.destinationType
    };
  }

  var defaultDestination = {};

  if (((_post$flightDestinati = post.flightDestinations) === null || _post$flightDestinati === void 0 ? void 0 : _post$flightDestinati.length) > 0) {
    var destination = post.flightDestinations[0];
    defaultDestination = {
      destination: destination.name,
      destination_id: destination.id,
      destination_type: destination.destinationType
    };
  }

  var defaultOriginDestination = _objectSpread(_objectSpread(_objectSpread({}, defaultOrigin), defaultDestination), {}, {
    itineraries: [_objectSpread(_objectSpread({
      departure_date: null
    }, defaultOrigin), defaultDestination), {
      departure_date: null
    }]
  });

  (0,react.useEffect)(function () {
    var destination = post.flightDestinations[0];
    appDispatch((0,flightSuggestionSlice/* setFlightDestinationInputData */.IO)({
      text: "",
      longName: destination === null || destination === void 0 ? void 0 : destination.name
    }));
  }, []);
  (0,react.useEffect)(function () {
    if ((0,responsiveStyle/* isDesktop */.nI)(breakpoint)) {
      (0,ScrollUtil/* stopBodyScrolling */.wV)(displayedPicker);
    }
  }, [displayedPicker]);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), defaultOriginDestination)
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              params = (0,searchFlightSlice/* convertSearchFlightFormValuesToParams */.uI)(values);
              return _context.abrupt("return", appDispatch((0,searchFlightSlice/* postSearchFlightCache */.re)({
                params: _objectSpread(_objectSpread({}, params), PostConstants/* PostSearchGAParams */.fy)
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* flightAvailabilitiesEvent */.t6)(cacheId, params);
                var gaParams = (0,lib.stringify)(PostConstants/* PostSearchGAParams */.fy, {
                  arrayFormat: "indices"
                });
                window.location.href = "".concat(Constants/* TABI_DOMAIN */.xQ, "/flights?").concat((0,lib.stringify)(params, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId, "&").concat(gaParams);
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);

                if (errorResponse.errors) {
                  if (Array.isArray(errorResponse.errors)) {
                    var errorMessages = errorResponse.errorMessages;
                    (0,FormUtil/* convertServerErrorToForm */.f)({
                      messages: errorMessages
                    }, setError);
                  } else {
                    // エラー形式を合わせるために変換している
                    var _errors = Object.keys(errorResponse.errors).map(function (key) {
                      return (0,defineProperty/* default */.Z)({}, key, errorResponse.errors[key]);
                    });

                    (0,FormUtil/* convertServerErrorToForm */.f)({
                      fieldMessages: _errors
                    }, setError);
                  }
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchFlightDestinationSuggestionsAction = function fetchFlightDestinationSuggestionsAction(data, type, index) {
    appDispatch((0,flightSuggestionSlice/* debouncedFetchFlightDestinationSuggestions */.tk)({
      params: {
        text: data.text
      },
      type: type,
      index: index
    }));
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var formFieldsStyles = isCompact ? [formFieldsStyle, formScrollStyle] : formFieldsStyle;

  var renderForm = function renderForm() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [isCompact && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: headerTitleStyle,
        children: t("post.flightSearch")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
        onSubmit: handleFormSubmit,
        css: formStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: formInnerStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: formFieldsStyles,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: flightTypeBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTypeBlock/* FlightTypeBlock */.c, {
                labelStyleKey: "labelDark",
                borderColorStyleKey: "primary"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginDestinationDate/* FlightOriginDestinationDate */.e, {
              destinationSuggestOptions: {},
              fetchFlightOriginDestinationSuggestions: fetchFlightDestinationSuggestionsAction,
              defaultOrigins: post.origins,
              defaultDestinations: post.flightDestinations,
              useDatePicker: true,
              searchType: SearchCategories/* searchCategories.flight */.M.flight,
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary",
              disableStopBodyScrolling: true
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: flightClassBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinClassBlock/* CabinClassBlock */.B, {
                labelColorStyleKey: "default",
                borderColorStyleKey: "primary"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTravelerBlock/* FlightTravelerBlock */.Z, {
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary"
            }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
                namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
                errors: errors,
                hideValidationErrors: true
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: submitBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: buttonBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
                type: "submit",
                disabled: isSubmitting,
                isLoading: isSubmitting,
                children: "\u691C \u7D22"
              })
            })
          })]
        })
      })]
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchFlight_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: isCompact ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFlightFieldButton, {
          onClick: onPickerButtonClick
        }), (0,responsiveStyle/* isDesktop */.nI)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDialogWithClose/* ModalDialogWithClose */.T, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          styleKey: "noInnerContentPadding",
          innerStyles: {
            maxWidth: maxWidthStyle/* maxWidth.page1col */.k.page1col,
            height: "680px"
          },
          children: renderForm()
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          colorMode: "light",
          children: renderForm()
        })]
      }) : renderForm()
    }))
  });
};
var SearchFlight_blockStyle =  true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0;
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
var formStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var formInnerStyle =  true ? {
  name: "13ku56z",
  styles: "display:flex;flex-direction:column;height:100%"
} : 0;
var formFieldsStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var formScrollStyle =  true ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : 0;
var flightTypeBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var flightClassBlockStyle =  true ? {
  name: "11vmki4",
  styles: "width:50%;min-width:200px"
} : 0;
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;justify-content:flex-end;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 10252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ SearchHotel; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/searchHotelSlice.ts
var searchHotelSlice = __webpack_require__(9296);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx + 3 modules
var GuestsBlock = __webpack_require__(88452);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDestinationBlock.tsx
var HotelDestinationBlock = __webpack_require__(83981);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDatePickerBlock.tsx
var HotelDatePickerBlock = __webpack_require__(65562);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 2 modules
var store = __webpack_require__(62394);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSuggestionSlice.ts
var hotelSuggestionSlice = __webpack_require__(86058);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/features/post/postSlice.ts
var postSlice = __webpack_require__(78121);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/features/post/components/SearchFieldButtonSymbol.tsx
var SearchFieldButtonSymbol = __webpack_require__(60629);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchHotelFieldButton.tsx









var SearchHotelFieldButton = function SearchHotelFieldButton(props) {
  var onClick = props.onClick;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var destinationFieldName = "destination";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: destinationFieldName
  }) || "";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: buttonStyle,
      onClick: onClick,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: destinationStyle,
        children: value
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFieldButtonSymbol/* SearchFieldButtonSymbol */.H, {})]
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:space-between;align-items:center;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var destinationStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding-right:", spaceStyle/* space.atom */.D.atom, ";overflow-wrap:anywhere;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts + 1 modules
var ModalDialogWithClose = __webpack_require__(99717);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
;// CONCATENATED MODULE: ./main/javascripts/features/post/components/SearchHotel.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




































yup_es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = yup_es/* object */.Ry().shape({
  destination: yup_es/* string */.Z_().nullable().required(),
  destination_id: yup_es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).required(),
  checkin_date: yup_es/* string */.Z_().nullable().required(),
  checkout_date: yup_es/* string */.Z_().nullable().required(),
  guests: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
    number_of_children: yup_es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: yup_es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
        age: yup_es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var defaultValues = {
  destination: "",
  checkin_date: null,
  // undefinedではダメ
  checkout_date: null,
  // undefinedではダメ
  number_of_rooms: 1,
  guests: [{
    number_of_adult: 2,
    number_of_children: 0,
    ages_of_children: []
  }]
};
var SearchHotel = function SearchHotel(props) {
  var _post$hotelDestinatio;

  var _props$isCompact = props.isCompact,
      isCompact = _props$isCompact === void 0 ? false : _props$isCompact;
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var post = (0,store/* useAppSelector */.CG)(postSlice/* postSelector */.pm); // TODO: 旧reducer

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  var defaultDestination = {};

  if (((_post$hotelDestinatio = post.hotelDestinations) === null || _post$hotelDestinatio === void 0 ? void 0 : _post$hotelDestinatio.length) > 0) {
    var destination = post.hotelDestinations[0];
    defaultDestination = {
      destination: destination.name,
      destination_id: destination.id,
      destination_type: destination.destinationType,
      longitude: destination.centerCoordinates[0],
      latitude: destination.centerCoordinates[1]
    };
  }

  (0,react.useEffect)(function () {
    var destination = post.hotelDestinations[0];
    appDispatch((0,hotelSuggestionSlice/* setHotelDestinationInputData */.Hx)({
      text: "",
      longName: destination === null || destination === void 0 ? void 0 : destination.name
    }));
  }, []);
  (0,react.useEffect)(function () {
    if ((0,responsiveStyle/* isDesktop */.nI)(breakpoint)) {
      (0,ScrollUtil/* stopBodyScrolling */.wV)(displayedPicker);
    }
  }, [displayedPicker]);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), defaultDestination)
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values, _) {
      var submitValues;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitValues = (0,searchHotelSlice/* convertSearchHotelFormValuesToParams */.Dh)(values);
              setIsSubmitting(true);
              return _context.abrupt("return", appDispatch((0,searchHotelSlice/* postSearchHotelCache */.Yw)({
                params: _objectSpread(_objectSpread({}, submitValues), PostConstants/* PostSearchGAParams */.fy)
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,ScrollUtil/* stopBodyScrolling */.wV)(false);
                (0,googleTagManagerUtil/* hotelAvailabilitiesEvent */.yb)(cacheId, submitValues);
                var gaParams = (0,lib.stringify)(PostConstants/* PostSearchGAParams */.fy, {
                  arrayFormat: "indices"
                });
                window.location.href = "".concat(Constants/* TABI_DOMAIN */.xQ, "/hotels?").concat((0,lib.stringify)(submitValues, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId, "&").concat(gaParams);
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);

                if (Array.isArray(errorResponse.errors)) {
                  var errorMessages = errorResponse.errorMessages;
                  (0,FormUtil/* convertServerErrorToForm */.f)({
                    messages: errorMessages
                  }, setError);
                } else {
                  // エラー形式を合わせるために変換している
                  var _errors = Object.keys(errorResponse.errors).map(function (key) {
                    return (0,defineProperty/* default */.Z)({}, key, errorResponse.errors[key]);
                  });

                  (0,FormUtil/* convertServerErrorToForm */.f)({
                    fieldMessages: _errors
                  }, setError);
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchHotelDestinationSuggestionsAction = function fetchHotelDestinationSuggestionsAction(data) {
    appDispatch((0,hotelSuggestionSlice/* debouncedFetchHotelDestinationSuggestions */.y$)({
      params: {
        text: data.text,
        excluded_code: "JP"
      }
    }));
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var formFieldsStyles = isCompact ? [formFieldsStyle, formScrollStyle] : formFieldsStyle;

  var renderForm = function renderForm() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [isCompact && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: headerTitleStyle,
        children: t("post.hotelSearch")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
        onSubmit: handleFormSubmit,
        css: formStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: formInnerStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: formFieldsStyles,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: destBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDestinationBlock/* HotelDestinationBlock */.h, {
                fetchHotelDestinationSuggestions: fetchHotelDestinationSuggestionsAction,
                defaultDestinations: post.hotelDestinations,
                labelColorStyleKey: "default",
                borderColorStyleKey: "primary",
                disableStopBodyScrolling: true
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDatePickerBlock/* HotelDatePickerBlock */.F, {
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary",
              disableStopBodyScrolling: true
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
              labelColorStyleKey: "default",
              borderColorStyleKey: "primary"
            }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
                namespace: FormConstants/* FormNamespaces.hotel */.Z.hotel,
                errors: errors,
                hideValidationErrors: true
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: submitBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: buttonBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
                type: "submit",
                disabled: isSubmitting,
                isLoading: isSubmitting,
                children: "\u691C \u7D22"
              })
            })
          })]
        })
      })]
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchHotel_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: isCompact ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotelFieldButton, {
          onClick: onPickerButtonClick
        }), (0,responsiveStyle/* isDesktop */.nI)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDialogWithClose/* ModalDialogWithClose */.T, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          styleKey: "noInnerContentPadding",
          innerStyles: {
            maxWidth: maxWidthStyle/* maxWidth.page1col */.k.page1col,
            height: "680px"
          },
          children: renderForm()
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
          displayed: displayedPicker,
          closeHandler: hidePicker,
          colorMode: "light",
          children: renderForm()
        })]
      }) : renderForm()
    }))
  });
};
var SearchHotel_blockStyle =  true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0;
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
var formStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var formInnerStyle =  true ? {
  name: "13ku56z",
  styles: "display:flex;flex-direction:column;height:100%"
} : 0;
var formFieldsStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:100%;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var formScrollStyle =  true ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : 0;
var destBlockStyle =  true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0;
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;justify-content:flex-end;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 30274:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktcGx1cyIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBkPSJNOCA0YS41LjUgMCAwIDEgLjUuNXYzaDNhLjUuNSAwIDAgMSAwIDFoLTN2M2EuNS41IDAgMCAxLTEgMHYtM2gtM2EuNS41IDAgMCAxIDAtMWgzdi0zQS41LjUgMCAwIDEgOCA0eiIvPgo8L3N2Zz4K"

/***/ })

}]);